import React, { useState, useEffect, useMemo, useCallback } from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import { styled } from '@material-ui/styles';
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import { Button, Card, CardContent } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import UpdateIcon from '@mui/icons-material/Update';
import Chip from '@mui/material/Chip';
import InfoIcon from '@mui/icons-material/Info';
 
import moment from 'moment';
import { useParams } from "react-router-dom";
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import AppBar from '@mui/material/AppBar';
import SettingsIcon from '@mui/icons-material/Settings';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { Stack } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { Divider } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';



import {

    Tooltip
} from '@mui/material';
import {
    MaterialReactTable,

} from 'material-react-table';

import Paper from '@material-ui/core/Paper';
import api from '../../../../../../services/api';
import { returnDescricaoInsumo } from '../../../../../../utils/insumoHelpers';

import NavegadorGestao from "../../../../../../components/NavBarGestao";
import OrdemComprasComponent from "../../../../../../pages/painelAdmin/AreaGestao/ModuloAdministracao/OrdensDeCompras/ordemComprasComponent";

import miniatura_pdf from '../../../../../../assets/imgs/miniatura_pdf.png';

import Box from '@material-ui/core/Box';
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {
    DataGrid,  
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';






const ColorButtonRed = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'red',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'red',
        color: 'whit',
        borderColor: 'red',
    },
}));



const dropzoneStyles = {
    border: '4px dashed #000000',
    borderRadius: '4px',
    padding: '2px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '2px 0',
};



export default function EditarProposta() {

    const [loading, setLoading] = useState(true);

    const [value, setValue] = React.useState(0);
 
      const [valorTaxadoCO, setValorTaxadoCO] = useState(0.0);
      const [valorTaxadoDespesaCO, setValorTaxadoDespesaCO] = useState(0.0);
     const [valorTaxadoReceitaCO, setValorTaxadoReceitaCO] = useState(0.0);

    
        const [valorTotalTaxadoCO, setValorTotalTaxadoCO] = useState(0.0);
      const [valorTotalTaxadoDespesaCO, setValorTotalTaxadoDespesaCO] = useState(0.0);
     const [valorTotalTaxadoReceitaCO, setValorTotalTaxadoReceitaCO] = useState(0.0);

     const handleSetValorUnitarioCO = ( newValue) => {

        setValorUnitarioCO(newValue);
        setValorTotalCO(newValue * quantidadeItemCO * periodoCO);

        setValorTotalTaxadoReceitaCO(valorTotalTaxadoReceitaCO * quantidadeItemCO * periodoCO );
        setValorTotalTaxadoDespesaCO(valorTotalTaxadoDespesaCO * quantidadeItemCO * periodoCO );
        setValorTotalTaxadoCO(valorTotalTaxadoCO * quantidadeItemCO * periodoCO );

    }


     const handlePeriodoCO = ( newValue) => {

        setPeriodoCO(newValue);
        setValorTotalCO(valorUnitarioCO * quantidadeItemCO * newValue);

        setValorTotalTaxadoReceitaCO(valorTaxadoReceitaCO * quantidadeItemCO * newValue );
        setValorTotalTaxadoDespesaCO(valorTaxadoDespesaCO * quantidadeItemCO * newValue );
        setValorTotalTaxadoCO(valorTaxadoCO * quantidadeItemCO * newValue );
    }

     const handleQuantidadeItemCO = ( newValue) => {

        setQuantidadeItemCO(newValue);
        setValorTotalCO(valorUnitarioCO * newValue * periodoCO);

        setValorTotalTaxadoReceitaCO(valorTaxadoReceitaCO * newValue * periodoCO );
        setValorTotalTaxadoDespesaCO(valorTaxadoDespesaCO * newValue * periodoCO );
        setValorTotalTaxadoCO(valorTaxadoCO * newValue * periodoCO );
    }



    const handleChange = (event, newValue) => {
        setValue(newValue);

    }

    const [numItens, setNumItens] = useState(0);
    const [quantItens, setQuantItens] = useState(0);

    const formatarDataPtBr = (dataIso) => {
        if (!dataIso) return '';
        const data = new Date(dataIso);
        if (isNaN(data)) return '';
        return data.toLocaleDateString('pt-BR');
    };


    const [selectedItems, setSelectedItems] = useState([]);

    const handleSelectionChange = (selectionModel) => {

        // Obtém os IDs das linhas selecionadas
        const selectedIDs = new Set(selectionModel);
        // Filtra os itens com base nos IDs selecionados
        const selectedRows = itensRequerimento.filter((row) => selectedIDs.has(row.id_item_requerimento));
        setSelectedItems(selectedRows);

    };



   const handleCustosOperacionaisSelecionados = (updater) => {
  setCustosOperacionaisSelecionados(prev =>
    typeof updater === 'function' ? updater(prev) : updater
  );
};

    function CustomToolbar() {
        return (
            <GridToolbarContainer
                container
                direction="row"
                alignItems="center"
                justifyContent={"center"}
            >
                <Grid
                    direction="row"
                    container
                    alignItems="flex-start"
                    justifyContent={"flex-start"}
                >
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton />
                    <GridToolbarDensitySelector />
                    <GridToolbarExport />
                </Grid>
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box display="flex" alignItems="center">
                        <span style={{ fontSize: 18, marginRight: 5 }}> {"Número de Itens: "} </span>
                        <span style={{ fontSize: 22, marginRight: 15, fontWeight: 'bold' }}> {numItens} </span>
                        <span style={{ fontSize: 18, marginRight: 5 }}> {" Quantidade de Itens: "} </span>
                        <span style={{ fontSize: 22, marginRight: 5, fontWeight: 'bold' }}> {quantItens} </span>


                    </Box>
                </Grid>
                {selectedItems.length > 0 && <Grid
                    container
                    direction="row"
                    alignItems="flex-end"
                    justifyContent="flex-end"
                    spacing={2}
                >
                    <ColorButtonRed variant="outlined" color="secondary"
                        onClick={handleClickRemoverSelecionados}
                    >
                        Remover Selecionados
                    </ColorButtonRed>

                    <ColorButtonRed variant="outlined" color="primary"
                        onClick={handleClickSolicitarOrdemCompra}
                    >
                        Solicitar Ordem de Compra
                    </ColorButtonRed>
                </Grid>
                }

            </GridToolbarContainer >
        );
    }

    const handleCellClick = (param, event) => {
        event.stopPropagation();
    };

    const handleRowClick = (param, event) => {
        event.stopPropagation();
    };

    const currencyFormatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const handleChangeIndex = (index) => {
        setValue(index);
    };


      const [valueOrcamentos, setValueOrcamentos] = React.useState(0);

    const handleChangeOrcamentos = (event, newValue) => {
        setValueOrcamentos(newValue);

    }
const handleChangeIndexOrcamentos = (index) => {
        setValueOrcamentos(index);
    };


    const history = useHistory();
    const location = useLocation();

    const [descricaoProposta, setDescricaoProposta] = useState('');
    const [diasValidade, setDiasValidade] = useState('');
    const [diasInicioInstalacao, setDiasInicioInstalacao] = useState('');
    const [diasInstalacao, setDiasInstalacao] = useState('');
    const [nivelSla, setNivelSla] = useState('');
    const [itens, setItens] = useState([]);
    const [custosOperacionais, setCustosOperacionais] = useState([]);
    const [servicosOperacionais, setServicosOperacionais] = useState([]);

    const [custosOperacionaisSelecionados, setCustosOperacionaisSelecionados] = useState([]);


    const [servicoOperacionalSelecionado, setServicoOperacionalSelecionado] = useState(null);

     const [descricaoItemCO, setDescricaoItemCO] = useState("");
    const [unidadeItemCO, setUnidadeItemCO] = useState("");
    const [quantidadeItemCO, setQuantidadeItemCO] = useState(0);
    const [periodoCO, setPeriodoCO] = useState(0);
    const [periodicidadeCO, setPeriodicidadeCO] = useState("");
    const [valorUnitarioCO, setValorUnitarioCO] = useState(0);
    const [valorTotalCO, setValorTotalCO] = useState(0);

    const [proposta, setProposta] = useState(null);

    const { idProjeto } = useParams();

    const { idProposta } = useParams();


    const { telaRetorno } = useParams();

    const { idInstalacao } = useParams();

    const { idCliente } = useParams();


    const [arquivos, setArquivos] = useState(null);

    const [instalacao, setInstalacao] = useState(null);
    const [valorTotalCustoPrevisto, setValorTotalCustoPrevisto] = useState(0);
        const [valorTotalLucroPrevisto, setValorTotalLucroPrevisto] = useState(0);
    const [valorTotalPrevisto, setValorTotalPrevisto] = useState(0);


     const [valorTotalCustoCOPrevisto, setValorTotalCustoCOPrevisto] = useState(0);
        const [valorTotalLucroCOPrevisto, setValorTotalLucroCOPrevisto] = useState(0);
    const [valorTotalPrevistoCO, setValorTotalPrevistoCO] = useState(0);

    const [projeto, setProjeto] = useState(null);

    const [descricaoItem, setDescricaoItem] = useState("");
    const [unidadeItem, setUnidadeItem] = useState("");
    const [quantidadeItem, setQuantidadeItem] = useState(0);
    const [quantidadeTotal, setQuantidadeTotal] = useState(0);
    const [periodicidade, setPeriodicidade] = useState("");
    const [valorUnitario, setValorUnitario] = useState(0);
    const [valorTotal, setValorTotal] = useState(0);


    const [ordensServicos, setOrdensServicos] = useState(null);
    const [lancamentos, setLancamentos] = useState(null);

    const [dataPrevistaInicio, setDataPrevistaInicio] = useState(null);
    const [dataPrevistaConclusao, setDataPrevistaConclusao] = useState(null);

 const [descreverSeparadamente, setDescreverSeparadamente] = useState(false);

  const handleChangeDescrever = (event) => {
    setDescreverSeparadamente(event.target.checked);
  };



  
 const [descreverSeparadamenteCO, setDescreverSeparadamenteCO] = useState(false);

  const handleChangeDescreverCO = (event) => {
    setDescreverSeparadamenteCO(event.target.checked);
  };


    const onDropArquivo1 = useCallback(async (acceptedFiles) => {
        // Valida o tipo de arquivo
        // Valida o tipo de arquivo
        if (!acceptedFiles[0].type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
            alert('Apenas arquivos Excel são permitidos.');
            return;
        }

        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }


            const formData = new FormData();
            formData.append('arquivos', acceptedFiles[0]);
            formData.append('extensao', acceptedFiles[0].name.split('.').pop());

  const id_usuario_logado = parseInt(Cookies.get("id_usuario"));
            await api.post("/v1/protected/projetos/proposta/upload/" + idProposta + "/" +id_usuario_logado , formData, {
                headers: headers
            }).then(function (response) {

                const cadastro_salvo = response.data;
                if (cadastro_salvo) {



                    const sortedItensPreRequerimento = response.data.proposta.itens_pre_requerimento.sort((a, b) => a.id_item_na_lista - b.id_item_na_lista);

                    // Atualiza o estado com a ordem de serviço e os itens ordenados
                    setItensRequerimento(sortedItensPreRequerimento);

                    setNumItens(sortedItensPreRequerimento.length);
                    const totalQuantItens = sortedItensPreRequerimento.reduce((total, item) => total + item.quantidade, 0);
                    setQuantItens(totalQuantItens);


                    api.get("v1/protected/almoxarifado/estoque/listarporinsumo", {
                        headers: headers
                    }).then(function (response) {
                        setInsumos(response.data)
                    });

                    alert("Arquivo Lido!");

                } else {
                    // Lógica a ser executada caso ocorra algum erro durante o salvamento
                    alert("Erro ao processar, insira os itens manualmente!");
                }


            });





        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");
        }
    }, []);

    const formatarMoeda = (valor) => {
    const numero = Number(valor);
    return isNaN(numero)
        ? 'R$ 0,00'
        : numero.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
};

    const { getRootProps: getRootArquivoProps1, getInputProps: getInputArquivoProps1 } = useDropzone({
        onDrop: onDropArquivo1,
        multiple: false, // Apenas um arquivo pode ser selecionado
        //accept: '.pdf', // Restringe a aceitação apenas para arquivos .pdf

    });



      async function handleAdicionarTaxaIndividualInsumo  (event, novaLista) {
               try {

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }


            const antigaLista = proposta.taxas_individuais_insumos ;

    // Verifica qual item foi adicionado
    const taxaAdicionada = novaLista.find(
        (nova) => !antigaLista.some((antiga) => antiga.id_taxa === nova.id_taxa)
    );

    if (taxaAdicionada) {
        
   

                                                                                              
            const response = await api.put("/v1/protected/projetos/proposta/" + idProposta + "/inserirtaxaindividualinsumos/" + taxaAdicionada.id_taxa,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Taxa adicionada!");
                listarInformacoes();

            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }

 }
        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }

        };
    

    async function handleRemoverTaxaIndividualInsumo(taxa) {

 
        try {

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }



            const response = await api.delete("/v1/protected/projetos/proposta/" + idProposta + "/removertaxaindividualinsumo/" + taxa.id_taxa ,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Taxa sobre insumos removida! É necessário atualizar calculos de taxamento de insumos");
                listarInformacoes();

            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }


    };





    
      async function handleAdicionarTaxaOperacional  (event, novaLista) {
               try {

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }


            const antigaLista = proposta.taxas_operacao ;

    // Verifica qual item foi adicionado
    const taxaAdicionada = novaLista.find(
        (nova) => !antigaLista.some((antiga) => antiga.id_taxa === nova.id_taxa)
    );

    if (taxaAdicionada) {
        
   

                                                                                              
            const response = await api.put("/v1/protected/projetos/proposta/" + idProposta + "/inserirtaxaoperacao/" + taxaAdicionada.id_taxa,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Taxa adicionada!");
                listarInformacoes();

            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }

 }
        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }

        };
    

    async function handleRemoverTaxaOperacional(taxa) {

 
        try {

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }



            const response = await api.delete("/v1/protected/projetos/proposta/" + idProposta + "/removertaxaoperacional/" + taxa.id_taxa ,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Taxa sobre insumos removida! É necessário atualizar calculos de taxamento de custos operacionais");
                listarInformacoes();

            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }


    };



    async function handleClickRemocao(cellValues) {


        const id_usuario_logado = parseInt(Cookies.get("id_usuario"));
        if (parseInt(id_usuario_logado, 10) !== cellValues.usuario_criador.id_usuario) {
            window.alert("Somente o usuário criador do Item pode remove-ló!");
            return;
        }

        try {

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }



            const response = await api.delete("/v1/protected/projetos/proposta/" + idProposta + "/removeritem/" + cellValues.id_item_proposta,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Removido!");
                listarInformacoes();

            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }


    };




    function handleClickSolicitarOrdemCompra() {

        const categoria = 0;

        history.push({
            pathname: '/gestao/administracao/ordensdeservicos/cadastrarordemservico',
            state: { categoriaCad: categoria, projetoCad: projeto, propostaCad: proposta, itensCad: selectedItems }
        });

    }



    async function handleClickRemoverSelecionados() {



        try {

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const id_usuario_logado = parseInt(Cookies.get("id_usuario"));


            const itens = {
  itens_pre_requerimento: selectedItems.map(item => ({ id_item_requerimento: item.id_item_requerimento }))
};
           

            const response = await api.delete(
                "/v1/protected/projetos/proposta/" + idProposta + "/removerinsumos",
                {
                    headers: headers,
                    data: itens // Aqui estamos incluindo o corpo da requisição no campo 'data'
                }
            );

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Itens selecionados removidos!");



                listarInformacoes();


            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }




    };




    async function handleClickRemoverCustosOperacionaisSelecionados() {



        try {

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const id_usuario_logado = parseInt(Cookies.get("id_usuario"));


     const itens = {
  custos_operacao: Object.keys(custosOperacionaisSelecionados).map(rowId => {
    const item = custosOperacionais.find(i => i.id_custo_operacao.toString() === rowId);
    return { id_custo_operacao: item.id_custo_operacao };
  })
};     

            const response = await api.delete(
                "/v1/protected/projetos/proposta/" + idProposta + "/removercustosoperacionais",
                {
                    headers: headers,
                    data: itens // Aqui estamos incluindo o corpo da requisição no campo 'data'
                }
            );

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Itens selecionados removidos!");



                listarInformacoes();


            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }




    };





    function checkarCancelamento() {
        if (parseInt(proposta.status_proposta, 10) === 9) {
            window.alert("A proposta está cancelada");
            return true;
        }
        return false;
    }


    async function novoItem() {

        if (checkarCancelamento())
            return null;
        // Obtém o próximo ID

        // Cria um novo item com os valores das constantes



        try {

            console.log("cadastrar chamado");
            const id_usuario_logado = parseInt(Cookies.get("id_usuario"));

            const cadastro = {
                descricao: descricaoItem,
                unidade_medida: unidadeItem,
                quantidade: quantidadeItem,
                quantidade_total: quantidadeTotal,
                periodicidade: periodicidade,
                valor_unitario: valorUnitario,
                valor_total: valorTotal,
                usuario_criador: { id_usuario: id_usuario_logado },

            };


            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }



            const response = await api.put("/v1/protected/projetos/proposta/" + idProposta + "/inseriritem", cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                const sortedItensPreRequerimento = response.data.itens_pre_requerimento.sort((a, b) => a.id_item_na_lista - b.id_item_na_lista);

                setItensRequerimento(sortedItensPreRequerimento);
                setNumItens(sortedItensPreRequerimento.length);
                const totalQuantItens = sortedItensPreRequerimento.reduce((total, item) => total + item.quantidade, 0);
                setQuantItens(totalQuantItens);

                setArquivos(response.data);

                const somatoria = response.data.itens.reduce((sum, item) => sum + item.valor_total, 0);
                setSomatoria(somatoria);
                listarInformacoes();
                // Limpa os valores das constantes
                setDescricaoItem('');
                setUnidadeItem('');
                setQuantidadeItem('');
                setQuantidadeTotal('');
                setPeriodicidade('');
                setValorUnitario('');
                setValorTotal('');


            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }



    }



    const handleClickExcluirItemProposta = (event, cellValues) => {

        const id = cellValues.row.id_item_proposta;


        // Crie um novo array que exclua o item com o ID correspondente
        const novoArrayItens = itens.filter(item => item.id_item_proposta !== id);

        // Atualize o array de itens com o novo array
        setItens(novoArrayItens);

    };



     async function novoCustoOperacional() {

        if (checkarCancelamento())
            return null;
        // Obtém o próximo ID

        // Cria um novo item com os valores das constantes



        try {

            if(servicoOperacionalSelecionado === null){
                window.alert("Selecione o Serviço Operacional!");
                return;
            }

            console.log("cadastrar chamado");
            const id_usuario_logado = parseInt(Cookies.get("id_usuario"));

            const cadastro = {
                descricao: descricaoItemCO,
                unidade_medida: unidadeItemCO,
                quantidade: quantidadeItemCO,
                periodo: periodoCO,
                periodicidade: periodicidadeCO,
              
                usuario_criador: { id_usuario: id_usuario_logado },
                servico_operacao: { id_servico_operacao: servicoOperacionalSelecionado.id_servico_operacao },
                descrever_separadamente: descreverSeparadamenteCO ? 1 : 0,

                valor_unitario: valorUnitarioCO,
                valor_total: valorTotalCO,

                valor_taxado: valorTaxadoCO,
                valor_total_taxado: valorTotalTaxadoCO,

                valor_taxado_receita: valorTaxadoReceitaCO,
                valor_total_taxado_receita: valorTotalTaxadoReceitaCO,

                valor_taxado_despesa: valorTaxadoDespesaCO,
                valor_total_taxado_despesa: valorTotalTaxadoDespesaCO,


            };


            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }



            const response = await api.put("/v1/protected/projetos/proposta/" + idProposta + "/inserircustooperacional", cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
               
                listarInformacoes();
                // Limpa os valores das constantes
                setDescricaoItemCO('');
                setUnidadeItemCO('');
                setQuantidadeItemCO(0);
                setPeriodoCO(0);
                setPeriodicidadeCO('');
                setValorUnitarioCO(0);
                setValorTotalCO(0);

                setValorTaxadoCO(0);
                setValorTotalTaxadoCO(0);

                setValorTotalTaxadoReceitaCO(0);
                setValorTaxadoReceitaCO(0);

                setValorTotalTaxadoDespesaCO(0);
                setValorTaxadoDespesaCO(0);

                setServicoOperacionalSelecionado(null);


            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }



    }


    

    async function handleClickRemoverCustoOperacional(cellValues) {


        const id_usuario_logado = parseInt(Cookies.get("id_usuario"));
        if (parseInt(id_usuario_logado, 10) !== cellValues.usuario_criador.id_usuario) {
            window.alert("Somente o usuário criador do Item pode remove-ló!");
            return;
        }

        try {

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }



            const response = await api.delete("/v1/protected/projetos/proposta/" + idProposta + "/removercustooperacional/" + cellValues.id_custo_operacao,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Removido!");
                listarInformacoes();

            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }


    };


    const [colunas, setColunas] = useState(null);
    const [taxas, setTaxas] = useState([]);
    const [somatoria, setSomatoria] = useState(0.0);

        const [colunasCustosOperacionais, setColunasCustosOperacionais] = useState(null);
    const [somatoriaCO, setSomatoriaCO] = useState(0.0);

    const [itensRequerimento, setItensRequerimento] = useState([]);


    const returnDescricaoStatusProposta = (status_proposta) => {
        const statusMap = {
            0: "Aberta",
            1: "Elaborada",
            2: "Aguardando Aprovação",
            3: "Aprovada",
            9: "Cancelada"
        };

        return statusMap[status_proposta] || "Status Desconhecido";
    };


    async function listarInformacoes() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }


            await api.get("/v1/protected/projetos/listarporidsimples/" + idProjeto, {
                headers: headers
            }).then(function (response) {
                setProjeto(response.data);

                   api.get("/v1/protected/servicooperacional/listartodos", {
                    headers: headers
                }).then(function (response3) {
                    setServicosOperacionais(response3.data);
                          });


                              api.get("/v1/protected/financeiro/taxas/listartodos", {
                    headers: headers
                }).then(function (response4) {
                    setTaxas(response4.data);
                          });

                api.get("/v1/protected/projetos/propostas/listarporidpropostasimples/" + idProposta, {
                    headers: headers
                }).then(function (response) {

                    setProposta(response.data);

                    setValorTotalPrevistoCO(response.data.valor_operacional_total);
                    setValorTotalCustoCOPrevisto(response.data.custo_operacional_total);
                    setValorTotalLucroCOPrevisto(response.data.lucro_operacional_total);

                    setNovoStatus(response.data.status_proposta)
                    setDescricaoProposta(response.data.descricao_proposta);
                    setDiasInicioInstalacao(response.data.dias_inicio_instalacao);
                    setDiasInstalacao(response.data.dias_instalacao);
                    setDiasValidade(response.data.dias_validade);
                    setItens(response.data.itens);
                    setCustosOperacionais(response.data.custos_operacao);
                     const somatoriaCO = response.data.custos_operacao.reduce((sum, item) => sum + item.valor_total, 0);

                    setSomatoriaCO(somatoriaCO);

                    setDataPrevistaInicio(response.data.data_prevista_inicio);
                    setDataPrevistaConclusao(response.data.data_prevista_conclusao);

                    setNivelSla(response.data.nivel_sla);
                    console.log("NIvel: " + nivelSla);


                    const sortedItensPreRequerimento = response.data.itens_pre_requerimento.sort((a, b) => a.id_item_na_lista - b.id_item_na_lista);


                    setItensRequerimento(sortedItensPreRequerimento);

                    // 1. Soma total dos valores
                    setValorTotalCustoPrevisto(sortedItensPreRequerimento.reduce((total, item) => {
                        return total + (item.valor_total_taxado_despesa || 0);
                    }, 0))

                      setValorTotalLucroPrevisto(sortedItensPreRequerimento.reduce((total, item) => {
                        return total + (item.valor_total_taxado_receita || 0);
                    }, 0))


                     setValorTotalPrevisto(sortedItensPreRequerimento.reduce((total, item) => {
                        return total + (item.valor_total_taxado || 0);
                    }, 0))



                    setNumItens(sortedItensPreRequerimento.length);
                    const totalQuantItens = sortedItensPreRequerimento.reduce((total, item) => total + item.quantidade, 0);
                    setQuantItens(totalQuantItens);

                    setArquivos(response.data);



                     const colunasCustosOperacionais = [
                     {
                            accessorKey: 'id_custo_operacao', //normal accessorKey
                            header: 'ID',
                            size: 50,
                        },
                           {
                            accessorKey: 'servico_operacao.nome',
                            header: 'Serviço Operacional',
                            size: 200,

                        },
                        {
                            accessorKey: 'descricao',
                            header: 'Descricao',
                            size: 300,

                        },

                        {
                            accessorKey: 'unidade_medida',
                            header: 'Unidade',
                            size: 100,

                        },

                        {
                            accessorKey: 'quantidade',
                            header: 'Quantidade',
                            size: 100,

                        },

                        {
                            accessorKey: 'periodo',
                            header: 'Periodo',
                            size: 100,

                        },


                        {
                            accessorKey: 'periodicidade',
                            header: 'Periodicidade',
                            size: 100,

                        },

                        {
                            accessorKey: 'valor_unitario',
                            header: 'Valor Unitário',
                            size: 100,
                            Cell: ({ renderedCellValue }) => {
                                return parseFloat(renderedCellValue).toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL',
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                });
                            },

                        },

                        {
                            accessorKey: 'valor_total',
                            header: 'Valor Total',
                            size: 200,
                            Cell: ({ renderedCellValue }) => {
                                return parseFloat(renderedCellValue).toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL',
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                });
                            },
                          

                        },
       
                         {
        accessorKey: 'valor_taxado',
        header: 'Valor Unitário Taxado',
        size: 200,
        Cell: ({ renderedCellValue }) => {
            const valor = parseFloat(renderedCellValue ?? 0);
            return valor.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },
    },
    {
        accessorKey: 'valor_total_taxado',
        header: 'Valor Total Taxado',
        size: 200,
        Cell: ({ renderedCellValue }) => {
            const valor = parseFloat(renderedCellValue ?? 0);
            return valor.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },
    },
    {
        accessorKey: 'valor_taxado_despesa',
        header: 'Custo Unitário com taxas',
        size: 200,
        Cell: ({ renderedCellValue }) => {
            const valor = parseFloat(renderedCellValue ?? 0);
            return valor.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },
    },
    {
        accessorKey: 'valor_total_taxado_despesa',
        header: 'Custo Total com taxas',
        size: 200,
        Cell: ({ renderedCellValue }) => {
            const valor = parseFloat(renderedCellValue ?? 0);
            return valor.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },
    },
    {
        accessorKey: 'valor_taxado_receita',
        header: 'Lucro Unitário',
        size: 200,
        Cell: ({ renderedCellValue }) => {
            const valor = parseFloat(renderedCellValue ?? 0);
            return valor.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },
    },
    {
        accessorKey: 'valor_total_taxado_receita',
        header: 'Lucro Total',
        size: 200,
        Cell: ({ renderedCellValue }) => {
            const valor = parseFloat(renderedCellValue ?? 0);
            return valor.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },
    },
                        {
                            header: '',
                            id: 'criado_por',
                            size: 600,
                            accessorFn: row => {
                                return {
                                    criador: row.usuario_criador,
                                    data: row.data_hora_criacao,

                                };

                            },
                            Cell: ({ renderedCellValue }) => {
                                var nome = renderedCellValue.criador.nome_amigavel;
                                const data = moment(renderedCellValue.data, "YYYY-MM-DD HH:mm:ss");
                                const dataFormatada = data.format("DD/MM/YYYY [às] HH:mm");
                                return (
                                    <span style={{ fontSize: 14, color: 'black', fontSize: 'bold' }}>
                                        adicionado por {nome} em {dataFormatada}
                                    </span>
                                );
                            }
                        },
                         ];

                    setColunasCustosOperacionais(colunasCustosOperacionais);


                    const somatoria = response.data.itens.reduce((sum, item) => sum + item.valor_total, 0);

                    setSomatoria(somatoria);

                    const colunasTable = [

                        {
                            accessorKey: 'id_item_proposta', //normal accessorKey
                            header: 'ID',
                            size: 50,
                        },
                        {
                            accessorKey: 'descricao',
                            header: 'Descricao',
                            size: 500,

                        },

                        {
                            accessorKey: 'unidade_medida',
                            header: 'Unidade',
                            size: 100,

                        },

                        {
                            accessorKey: 'quantidade',
                            header: 'Quantidade',
                            size: 100,

                        },

                        {
                            accessorKey: 'quantidade_total',
                            header: 'Total',
                            size: 100,

                        },


                        {
                            accessorKey: 'periodicidade',
                            header: 'Periodicidade',
                            size: 100,

                        },

                        {
                            accessorKey: 'valor_unitario',
                            header: 'Valor Unitário',
                            size: 100,
                            Cell: ({ renderedCellValue }) => {
                                return parseFloat(renderedCellValue).toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL',
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                });
                            },

                        },

                        {
                            accessorKey: 'valor_total',
                            header: 'Valor Total',
                            size: 200,
                            Cell: ({ renderedCellValue }) => {
                                return parseFloat(renderedCellValue).toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL',
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                });
                            },
                            Footer: () => (
                                <Stack style={{ fontSize: 20, fontWeight: 'bold' }}>
                                    {currencyFormatter.format(somatoria)}
                                </Stack>
                            ),

                        },
                        {
                            header: '',
                            id: 'criado_por',
                            size: 600,
                            accessorFn: row => {
                                return {
                                    criador: row.usuario_criador,
                                    data: row.data_hora_criacao,

                                };

                            },
                            Cell: ({ renderedCellValue }) => {
                                var nome = renderedCellValue.criador.nome_amigavel;
                                const data = moment(renderedCellValue.data, "YYYY-MM-DD HH:mm:ss");
                                const dataFormatada = data.format("DD/MM/YYYY [às] HH:mm");
                                return (
                                    <span style={{ fontSize: 14, color: 'black', fontSize: 'bold' }}>
                                        adicionado por {nome} em {dataFormatada}
                                    </span>
                                );
                            }
                        },

                    ];

                    setColunas(colunasTable);

                    //listar os
                    api.get("/v1/protected/ordemservico/listarporproposta/" + idProposta, {
                        headers: headers
                    }).then(function (response) {

                        setOrdensServicos(response.data);

                    });

                    //listar lancamentos
                    api.get("/v1/protected/financeiro/lancamentos/listarporproposta/" + idProposta, {
                        headers: headers
                    }).then(function (response) {

                        setLancamentos(response.data);

                    });

                    api.get("/v1/protected/cliente/instalacoes/listarporid/" + idInstalacao, {
                        headers: headers
                    }).then(function (response) {
                        setInstalacao(response.data);


                        setLoading(false);




                    });


                });
            });


        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }

    }



    useEffect(() => {
        listarInformacoes();


    }, []);



    async function baixarArquivo(caminho) {
        try {
            const token = Cookies.get('token');
            const headers = {
                'Authorization': 'Bearer ' + token
            }

            const response = await api.post("/v1/protected/projetos/proposta/baixarPdf", { caminho: encodeURIComponent(caminho) }, {
                headers: headers,
                responseType: 'arraybuffer',  // Indica que a resposta é um array de bytes
            });

            // Cria um blob com os dados recebidos
            const blob = new Blob([response.data], { type: 'application/pdf' });

            // Cria uma URL do blob
            const blobUrl = URL.createObjectURL(blob);

            // Abre uma nova guia com o arquivo PDF
            window.open(blobUrl, '_blank');
        } catch (error) {
            // Trate os erros conforme necessário
            console.log("Erro ao baixar o arquivo: " + error);
        }
    }

    const espacamentoEntreBlocos = 4;


const tooltipStyle = {
  sx: {
    backgroundColor: '#fff',
    color: '#000',
    border: '1px solid #ccc',
    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.2)',
    fontSize: 13,
    padding: 1,
  },
};

    function returnDescricaoRetorno(instalacao) {
        var texto = instalacao.identificador_integrador + " | " + (instalacao.tipo_instalacao === 0 ? instalacao.cpf : instalacao.cnpj) +
            " | " + (instalacao.tipo_instalacao === 0 ? (instalacao.nome + " " + instalacao.sobrenome) : instalacao.nome_fantasia);

        return texto;
    }


    const [insumos, setInsumos] = useState([]);
    const [temEstoque, setTemEstoque] = useState(false);
    const [insumoSelecionado, setInsumoSelecionado] = useState(null);
    const [quantidade, setQuantidade] = useState(0);
    const [quantidadeDoEstoque, setQuantidadeDoEstoque] = useState(0);
    const [quantidadeNoEstoque, setQuantidadeNoEstoque] = useState(0);
    const [observacoesItem, setObservacoesItem] = useState('');
    const [descricaoNovoInsumo, setDescricaoNovoInsumo] = useState('');
    const [descricao, setDescricao] = useState('');


    function handleSetInsumo(insumo) {
        setInsumoSelecionado(insumo);
    }


    const [openTaxasInsumos, setOpenTaxasInsumos] = useState(false);


    function handleCloseTaxasInsumos () {
        setOpenTaxasInsumos(false);
    }

 
  function handleOpenTaxasInsumos () {
        setOpenTaxasInsumos(true);
    }


     const [openTaxasOperacionais, setOpenTaxasOperacionais] = useState(false);


    function handleCloseTaxasOperacionais () {
        setOpenTaxasOperacionais(false);
    }

 
  function handleOpenTaxasOperacionais () {
        setOpenTaxasOperacionais(true);
    }




   async function recalcular(){

      try {


 
  

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }



            const response = await api.get("/v1/protected/projetos/proposta/" + idProposta + "/recalculartaxasinsumos",
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                 listarInformacoes();
  

            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }

    }



    

   async function recalcularTaxasOperacionais(){

      try {


 
  

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }



            const response = await api.get("/v1/protected/projetos/proposta/" + idProposta + "/recalculartaxasoperacionais",
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                 listarInformacoes();
  

            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }

    }




    async function adicionarItem() {



            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }


        if (checkarCancelamento())
            return null;

        if (!insumoSelecionado) {
            if (descricaoNovoInsumo.length <= 0) {
                alert("Selecione o Insumo ou Insira a descrição para um novo Insumo!");
                return;
            } else {
 try {
                    const response = await api.get(
                        "/v1/protected/almoxarifado/insumos/semelhantes",
                        {
                            headers: headers,
                            params: { descricao: descricaoNovoInsumo }
                        }
                    );

                    const semelhantes = response.data;

                    if (semelhantes && semelhantes.length > 0) {
                        // Monta mensagem com as descrições semelhantes
                        const mensagens = semelhantes.map(i => i.descricao).join(", ");
                        alert("⚠️ Já existem insumos semelhantes: " + mensagens);
                        return; // impede adicionar até o usuário confirmar
                    }

                } catch (err) {
                    console.error("Erro ao buscar semelhantes:", err);
                    alert("Erro ao verificar insumos semelhantes. Tente novamente mais tarde.");
                    return;
                }
            }

        }

        if (!quantidade || parseInt(quantidade) <= 0) {
            alert("Informe a quantidade!");
            return;
        }

        try {


            const id_usuario_logado = parseInt(Cookies.get("id_usuario"));


            console.log("cadastrar chamado");
            const cadastro = {
                observacoes: observacoesItem,
                quantidade: parseInt(quantidade),
                insumo: insumoSelecionado !== null ? { id_insumo: insumoSelecionado.insumo.id_insumo } : null,
                descricao: descricaoNovoInsumo,
                usuario_criador: { id_usuario: id_usuario_logado },
                descrever_separadamente: descreverSeparadamente ? 1 : 0,
            

            }
 
            if(temEstoque){
                cadastro.quantidade_reservada = quantidadeDoEstoque;
                cadastro.quantidade_a_comprar = quantidade - quantidadeDoEstoque;
            }else{
                cadastro.quantidade_reservada = 0;    
                cadastro.quantidade_a_comprar = quantidade;    
            }

            if (insumoSelecionado) {
                cadastro.id_insumo = insumoSelecionado.insumo.id_insumo;
            }



            const response = await api.put("/v1/protected/projetos/proposta/" + idProposta + "/inseririnsumo", cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                //alert("Adicionado!");
                listarInformacoes();

                setInsumoSelecionado(null);
                setQuantidade(0);
                setObservacoesItem('');
                setDescricao('');
                setTemEstoque(false);
                setQuantidadeNoEstoque(0);
                setQuantidadeDoEstoque(0)
                setDescreverSeparadamente(false);


            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }




    }

    const [openMudarStatus, setOpenMudarStatus] = useState(false)
    const [motivo, setMotivo] = useState("");
    const [novoStatus, setNovoStatus] = useState(0);


    const handleOpenMudarStatus = (event, newValue) => {
        const id_usuario_logado = parseInt(Cookies.get("id_usuario"));
        if (parseInt(id_usuario_logado, 10) !== proposta.usuario_criador.id_usuario) {
            window.alert("Somente o usuário criador pode mudar o status da Proposta!");
            return;
        }
        setOpenMudarStatus(true);
    }

    const handleCloseMudarStatus = () => {
        setOpenMudarStatus(false);
    }




    async function handleClickMudarStatus() {


        try {
            const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
            const url = "/v1/protected/projetos/proposta/mudarstatus/" + idProposta + "/" + novoStatus + "/" + motivo;
            const response = await api.put(url, { headers });



            if (response.data) {
                alert("Status modificado!");
                setMotivo("");
                handleCloseMudarStatus();

                listarInformacoes();

            } else {
                alert("Erro ao Mudar Status!");
                return;
            }

        } catch (error) {
            alert("Erro ao Mudar Status!");
            return;
        }
    }

    async function handleClickRemoverInsumo(event, cellValues) {



        try {

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const id_usuario_logado = parseInt(Cookies.get("id_usuario"));


            const response = await api.delete("/v1/protected/projetos/proposta/" + idProposta + "/removerinsumo/" + cellValues.row.id_item_requerimento,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Removido!");

                listarInformacoes();


            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }


    };


    
 function handleSetQuantidadeDoEstoque(valor) {
    const valorNumerico = parseFloat(valor);

    if (valor === "") {
        setQuantidadeDoEstoque("");
        return;
    }

    if (!isNaN(valorNumerico) && valorNumerico <= quantidade && valorNumerico <= quantidadeNoEstoque) {
        setQuantidadeDoEstoque(valor);
    } else {
       // alert(`A quantidade informada deve ser no máximo ${Math.min(quantidade, quantidadeNoEstoque)}.`);
    }
}

    function handleSetInsumoSelecionado(insumo_) {
  try {
        const insumo = insumo_.insumo;
} catch (_err) {
          setInsumoSelecionado(null);

    return;
}

   try {
    if (Array.isArray(insumo_.itens_estoque) && insumo_.itens_estoque.length > 0) {
        const itensDisponiveis = insumo_.itens_estoque.filter(item => item.status_item === 0);
        
        if (itensDisponiveis.length > 0) {
            setTemEstoque(true);
            setQuantidadeNoEstoque(itensDisponiveis.length);
        } else {
            setTemEstoque(false);
            setQuantidadeNoEstoque(0);
        }
    } else {
        setTemEstoque(false);
        setQuantidadeNoEstoque(0);
    }
} catch (_err) {
    setTemEstoque(false);
    setQuantidadeNoEstoque(0);
    console.error("Erro ao verificar itens de estoque:", _err);
        setInsumoSelecionado(null);

    return;
}

    setInsumoSelecionado(insumo_);
}

    
    function returnDescricaoInsumo2(insumo_) {

        let insumo = insumo_.insumo;
        let textoComQuebraDeLinha = "Descrição Principal: " + insumo.descricao;

        if (insumo.variacoes && insumo.variacoes.length > 0) {
            textoComQuebraDeLinha += insumo.variacoes

                .map((variacao, index) => (
                    `<br />*Variação-> Fornecedor: ${variacao.nome_amigavel_fornecedor} Variação: ${variacao.descricao}${index !== insumo.variacoes.length - 1 ? '\n' : ''}`
                )).join('');
        }




        if (insumo.cotacoes && insumo.cotacoes.length > 0) {
            const cotacoesOrdenadas = [...insumo.cotacoes].sort((a, b) => new Date(a.data) - new Date(b.data));

            // Formata número para moeda brasileira
            const formatarValor = (valor) =>
                new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);

            // Formata data para pt-BR
            const formatarData = (data) =>
                new Date(data).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });

            // Constrói o texto com as cotações formatadas
            textoComQuebraDeLinha += cotacoesOrdenadas
                .map((cotacao, index) => {
                    return `<br />*Cotação -> ${formatarValor(cotacao.valor_unitario)} em ${formatarData(cotacao.data)}`;
                })
                .join('');

            // Cálculo da média
            const soma = cotacoesOrdenadas.reduce((acc, c) => acc + c.valor_unitario, 0);
            const media = soma / cotacoesOrdenadas.length;
            textoComQuebraDeLinha += `<br />Valor médio: ${formatarValor(media)}`;

            // Última cotação (maior data após ordenação)
            const ultimaCotacao = cotacoesOrdenadas[cotacoesOrdenadas.length - 1];
            textoComQuebraDeLinha += `<br />Última Cotação: ${formatarValor(ultimaCotacao.valor_unitario)} em ${formatarData(ultimaCotacao.data)}`;
        }else{
            textoComQuebraDeLinha += `<br />Sem cotações`;
        }

      if (insumo.taxa_a) {
    textoComQuebraDeLinha += `<br />Taxa: ${insumo.taxa_a.nome} | Valor: ${insumo.taxa_a.valor}% | Tipo: ${insumo.taxa_a.tipo_taxa == 0 ? "Despesa" : "Receita"}`;
}

if (insumo.taxa_b) {
    textoComQuebraDeLinha += `<br />Taxa: ${insumo.taxa_b.nome} | Valor: ${insumo.taxa_b.valor}% | Tipo: ${insumo.taxa_b.tipo_taxa == 0 ? "Despesa" : "Receita"}`;
}



      var quantidadeDisponivel = 0;

if (Array.isArray(insumo_.itens_estoque)) {
    quantidadeDisponivel = insumo_.itens_estoque.filter(item => item.status_item === 0).length;
}

var texto = textoComQuebraDeLinha + "<br />Estoque: " + quantidadeDisponivel + " unidades";
return texto;
    }

 

    const handleClickEdicao = (cellValues) => {
        const url = "/gestao/administracao/ordensdeservicos/editar/" + cellValues.id_ordem_servico;
        window.open(url, '_blank');
    };




    function returnDescricaoInsumoSimplificada(insumo) {
        try {
            // Tenta acessar diretamente insumo.descricao
            if (insumo?.descricao) {
                return  insumo.descricao;
            }

            // Se não houver, tenta insumo.insumo.descricao
            if (insumo?.insumo?.descricao) {
                return insumo.insumo.descricao;
            }

            // Se nenhum dos dois funcionar
            return "Descrição: não disponível";
        } catch (error) {
            return "Descrição: erro ao obter";
        }
    }

    const periodicidades = [
  'UNICO',
  'DIARIO',
  'SEMANAL',
  'QUINZENAL',
  'MENSAL',
  'TRIMESTRAL',
  'SEMESTRAL',
  'ANUAL'
];
    
const unidades = ['UNI', 'HORA', 'DIARIA', 'KM'];


 function returnDescricaoServicoOperacional(servico) {
       
            return servico.nome;
         
    }



   function returnDescricaoTaxa(taxa) {
  const tipo = taxa.tipo_taxa === 0 ? "Despesa" : "Receita";

  return (
    taxa.nome +
    "<br />" +
    taxa.descricao +
    "<br />Tipo da Taxa: " + tipo +
    "<br />Valor: " + taxa.valor + "%"
  );
}

    function calcularTotalTaxas(taxas) {
    return taxas?.reduce((total, taxa) => total + parseFloat(taxa.valor || 0), 0).toFixed(2);
}


function calcularTaxaEfetiva(taxas) {
    if (!taxas || taxas.length === 0) return 0;

    const multiplicador = taxas.reduce((acc, taxa) => acc * (1 + taxa.valor / 100), 1);
    const taxaEfetiva = (multiplicador - 1) * 100;

    return taxaEfetiva.toFixed(2);
}


    const columns = useMemo(
        () => [

            {
                accessorKey: 'id_ordem_servico', //normal accessorKey
                header: 'ID',
                size: 30,
                maxWidth: 30,
                id: 'id_ordem',


            },

            {
                header: 'Solicitação',
                id: 'solicitacao',
                size: 200,
                accessorFn: row => {
                    return {
                        solicitacao: row.solicitacao,

                    };

                },
                Cell: ({ renderedCellValue }) => {

                    if (renderedCellValue.solicitacao) {
                        return (
                            <span style={{ fontSize: 14, color: 'black', fontSize: 'bold' }}>
                                {returnDescricaoSolicitacao(renderedCellValue.solicitacao)}
                            </span>
                        );
                    } else {
                        return (
                            <span style={{ fontSize: 14, color: 'black', fontSize: 'bold' }}>
                            </span>
                        );

                    }


                }
            },
            {
                header: 'Descrição',
                id: 'descricao',
                size: 200,
                accessorFn: row => {
                    return {
                        descricao: row.descricao_solicitacao,

                    };

                },
                Cell: ({ renderedCellValue }) => {

                    return (
                        <span style={{ fontSize: 14, color: 'black', fontSize: 'bold' }}>
                            {renderedCellValue.descricao}
                        </span>
                    );
                }
            },
            {
                id: 'envolvidos',
                header: 'As partes',
                size: 250,
                maxWidth: 250,
                accessorFn: row => ({
                    analista: row.analista?.nome_amigavel || '',
                    criador: row.usuario_criador?.nome_amigavel || '',
                    solicitante: row.usuario_solicitante?.nome_amigavel || '',
                }),
                Cell: ({ renderedCellValue }) => (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        <span style={{ fontSize: 12, color: 'black' }}>
                            Solicitante: <strong>{renderedCellValue.solicitante}</strong>
                        </span>
                        <span style={{ fontSize: 12, color: 'black' }}>
                            Criador: <strong>{renderedCellValue.criador}</strong>
                        </span>
                        <span style={{ fontSize: 12, color: 'black' }}>
                            Analista: <strong>{renderedCellValue.analista}</strong>
                        </span>
                    </Box>
                ),
            }


 


        ],
        [],
    );



  


    const colunasInsumos = [
        {
            field: 'acoes',
            headerName: 'Ações',
            headerClassName: 'cabecalho_marrom_claro',
            sortable: false,
            width: 100,
            renderCell: (cellValues) => {

                return (
                    <ColorButtonRed variant="outlined" color="secondary"
                        onClick={(event) => handleClickRemoverInsumo(event, cellValues)}

                    >
                        Remover
                    </ColorButtonRed>
                )
            },
        },
        {
            headerName: 'Item',
            field: 'id_item_na_lista',
            id: 2,
            width: 50,
            headerClassName: 'cabecalho_azul',
        },

        {
            headerName: 'Insumo',
            field: 'insumo',
            id: 3,
            width: 700,
            headerClassName: 'cabecalho_azul',
            renderCell: (params) => {
                const insumo = params.row.insumo;
                let descricao = returnDescricaoInsumoSimplificada(insumo);
                descricao = descricao.replace(/<br\s*\/?>/gi, '\n');
                return <div style={{ whiteSpace: 'pre-line' }}>{descricao}</div>;
            },
        },


        {
            headerName: 'Qtd Necessária',
            field: 'quantidade',
            id: 4,
            headerClassName: 'cabecalho_azul',
        },
            {
            headerName: 'Qtd Reservada no Est',
            field: 'quantidade_reservada',
            id: 5,
            headerClassName: 'cabecalho_azul',
        },
            {
            headerName: 'Qtd a Comprar',
            field: 'quantidade_a_comprar',
            id: 6,
            headerClassName: 'cabecalho_azul',
        },
        {
            headerName: 'Valor Unitário sem taxas',
            field: 'valor_unitario_ultima_cotacao',
            id: 7,
            width: 200,
            headerClassName: 'cabecalho_azul',
            renderCell: (params) => {
                const valor = Number(params.row.valor_unitario_ultima_cotacao);
                return isNaN(valor)
                    ? 'R$ 0,00'
                    : valor.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    });
            },
        },
        {
            headerName: 'Valor Total sem taxas',
            field: 'valor_total_previsto',
            id: 8,
            width: 200,
            headerClassName: 'cabecalho_azul',
            renderCell: (params) => {
                const valor = Number(params.row.valor_total_previsto);
                return isNaN(valor)
                    ? 'R$ 0,00'
                    : valor.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    });
            },
        },

         {
            headerName: 'Valor Unitário Taxado',
            field: 'valor_taxado',
            id: 8,
            width: 200,
            headerClassName: 'cabecalho_azul',
            renderCell: (params) => {
                const valor = Number(params.row.valor_taxado);
                return isNaN(valor)
                    ? 'R$ 0,00'
                    : valor.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    });
            },
        },
         {
            headerName: 'Valor Total Taxado',
            field: 'valor_total_taxado',
            id: 8,
            width: 200,
            headerClassName: 'cabecalho_azul',
            renderCell: (params) => {
                const valor = Number(params.row.valor_total_taxado);
                return isNaN(valor)
                    ? 'R$ 0,00'
                    : valor.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    });
            },
        },

          {
            headerName: 'Custo Unitário com taxas',
            field: 'valor_taxado_despesa',
            id: 9,
            width: 200,
            headerClassName: 'cabecalho_azul',
            renderCell: (params) => {
                const valor = Number(params.row.valor_taxado_despesa);
                return isNaN(valor)
                    ? 'R$ 0,00'
                    : valor.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    });
            },
        },
         {
            headerName: 'Custo Total com taxas',
            field: 'valor_total_taxado_despesa',
            id: 10,
            width: 200,
            headerClassName: 'cabecalho_azul',
            renderCell: (params) => {
                const valor = Number(params.row.valor_total_taxado_despesa);
                return isNaN(valor)
                    ? 'R$ 0,00'
                    : valor.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    });
            },
        },

   {
            headerName: 'Lucro Unitário',
            field: 'valor_taxado_receita',
            id: 11,
            width: 200,
            headerClassName: 'cabecalho_azul',
            renderCell: (params) => {
                const valor = Number(params.row.valor_taxado_receita);
                return isNaN(valor)
                    ? 'R$ 0,00'
                    : valor.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    });
            },
        },
         {
            headerName: 'Lucro Total',
            field: 'valor_total_taxado_receita',
            id: 12,
            width: 200,
            headerClassName: 'cabecalho_azul',
            renderCell: (params) => {
                const valor = Number(params.row.valor_total_taxado_receita);
                return isNaN(valor)
                    ? 'R$ 0,00'
                    : valor.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    });
            },
        },

        {
            headerName: 'Observações',
            field: 'observacoes',
            id: 13,
            width: 100,
            headerClassName: 'cabecalho_azul',
        },
       {
  headerName: '',
  field: 'criado_por',
  id: 14,
  width: 600,
  headerClassName: 'cabecalho_azul',
  renderCell: (params) => {
    const criador = params.row.usuario_criador;
    const data_ori = params.row.data_hora_criacao;

    // Se o criador for nulo ou indefinido, define um valor padrão
    const nome = criador?.nome_amigavel ?? 'usuário desconhecido';

    // Se a data for nula ou inválida, mostra "data desconhecida"
    const dataValida = data_ori ? moment(data_ori, "YYYY-MM-DD HH:mm:ss") : null;
    const dataFormatada = dataValida?.isValid()
      ? dataValida.format("DD/MM/YYYY [às] HH:mm")
      : 'data desconhecida';

    return (
      <span style={{ fontSize: 14, color: 'black', fontWeight: 'bold' }}>
        adicionado por {nome} em {dataFormatada}
      </span>
    );
  },
}




    ];




    function returnDescricaoSolicitacao(solicitacao) {
        var texto = solicitacao.solicitacao;
        return texto;
    }


    function novaOS() {



        if (checkarCancelamento())
            return null;

        history.push({
            pathname: '/gestao/administracao/ordensdeservicos/cadastrarordemservico',
            state: {
                categoriaCad: "",
                projetoCad: projeto,
                propostaCad: proposta,
                itensCad: null,
                flagBack: 11,
                flagPath: location.pathname,
            },
        });
    }




    function novoLancamento() {



        if (checkarCancelamento())
            return null;

        history.push({
            pathname: '/gestao/financas/lancamento/cadastrar',
            state: {
                projetoCad: projeto,
                propostaCad: proposta,
                flagBack: 11,
                flagPath: location.pathname,
            },
        });
    }



const columnsLancamentos = [
    {
        field: 'acoes',
        headerName: 'Ações',
        headerClassName: 'cabecalho_marrom_claro',
        sortable: false,
        width: 120,
        renderCell: (cellValues) => (
            <ColorButtonRed
                variant="outlined"
                color="secondary"
                onClick={(event) => handleClickGerenciarLancamento(cellValues.row.id_lancamento)}
            >
                Gerenciar
            </ColorButtonRed>
        ),
    },
    {
        headerName: 'ID',
        field: 'id_lancamento',
        width: 50,
        headerClassName: 'cabecalho_azul',
    },
    {
        headerName: 'Data Lançamento',
        field: 'data_lancamento',
        width: 120,
        headerClassName: 'cabecalho_azul',
        renderCell: (cellValues) => (
            <span>{moment(cellValues.value).format('DD/MM/YYYY')}</span>
        ),
    },
    {
        headerName: 'Valor',
        field: 'valor',
        width: 100,
        headerClassName: 'cabecalho_azul',
        renderCell: (cellValues) => (
            <span>{currencyFormatter.format(cellValues.value)}</span>
        ),
    },
    {
        headerName: 'Tipo',
        field: 'tipo',
        width: 120,
        headerClassName: 'cabecalho_azul',
        renderCell: (cellValues) => {
            let text = '';
            switch (cellValues.value) {
                case 0: text = "DESPESA"; break;
                case 1: text = "RECEITA"; break;
                case 2: text = "EMPRÉSTIMO"; break;
                case 3: text = "TRANSFERÊNCIA"; break;
                default: text = ""; break;
            }
            return <span>{text}</span>;
        },
    },
    {
        headerName: 'Status',
        field: 'status',
        width: 100,
        headerClassName: 'cabecalho_azul',
        renderCell: (cellValues) => {
            const text = cellValues.value === 1 ? "PAGO" : "NÃO PAGO";
            return <span>{text}</span>;
        },
    },
    {
        headerName: 'Centro de Custo',
        field: 'centro_custo',
        width: 200,
        headerClassName: 'cabecalho_azul',
        renderCell: (cellValues) => (
            <span style={{ maxWidth: '300px', wordWrap: 'break-word', display: 'inline-block' }}>
                {cellValues.row.centro_custo?.nome || ''}
            </span>
        ),
    },
];




    function handleClickGerenciarLancamento(idLancamento) {
         const url = `/gestao/financas/lancamento/gerenciar/${idLancamento}`;
        window.location.href = url;
    }

    function returnDescricaoSolicitante(usuario) {
        const nome = usuario?.nome_amigavel || "Usuário desconhecido";

        let dataTexto = "";

        try {
            const dataString = proposta.data_hora_criacao;
            const data = moment(dataString, "YYYY-MM-DD HH:mm:ss");

            if (data.isValid()) {
                const dataFormatada = data.format("DD/MM/YYYY [às] HH:mm");
                const tempoRelativo = data.fromNow(); // Ex: "há 2 dias"
                dataTexto = ` em ${dataFormatada} (${tempoRelativo})`;
            } else {
                dataTexto = proposta.data_hora_criacao;
                console.warn("Data inválida:", dataString);
            }
        } catch (err) {
            console.error("Erro ao formatar data:", err);
            dataTexto = proposta.data_hora_criacao;
        }

        return `Está proposta foi criada por ${nome}${dataTexto}`;
    }

    function handleServicoOperacionalSelecionado(servico){

        setUnidadeItemCO(servico.unidade_medida);
        setDescricaoItemCO(servico.descricao);
        setPeriodoCO(servico.periodo);
        setPeriodicidadeCO(servico.periodicidade);
        setValorUnitarioCO(servico.valor_unitario);
        
        setValorTaxadoCO(servico.valor_taxado);
        setValorTaxadoDespesaCO(servico.valor_taxado_despesa);
        setValorTaxadoReceitaCO(servico.valor_taxado_receita);
        setServicoOperacionalSelecionado(servico);
    }

    
   async function handleClickAtualizarInsumosNaProposta() {
   
       if (checkarCancelamento())
            return null;
        // Obtém o próximo ID

        // Cria um novo item com os valores das constantes



        try {

            console.log("cadastrar chamado");
            const id_usuario_logado = parseInt(Cookies.get("id_usuario"));

            const cadastro = {
                 
                usuario_criador: { id_usuario: id_usuario_logado },

            };


            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }



            const response = await api.put("/v1/protected/projetos/proposta/" + idProposta + "/atualizarinsumosnaproposta", cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Atualizado!");
                listarInformacoes();
                


            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }


    }



      async function handleClickAtualizarMaoDeObraNaProposta() {
   
      if (parseInt(proposta.status_proposta, 10) === 9) {
            window.alert("A proposta está cancelada");
            return null;
        }
       


        try {

            console.log("cadastrar chamado");
            const id_usuario_logado = parseInt(Cookies.get("id_usuario"));

            const cadastro = {
                
                usuario_criador: { id_usuario: id_usuario_logado },

            };


            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }



            const response = await api.put("/v1/protected/projetos/proposta/" + idProposta + "/atualizarcustosoperacionaisnaproposta", cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Atualizado!");
                listarInformacoes();
                


            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }


    }


    
    const [textoBusca, setTextoBusca] = useState("");
    
        useEffect(() => {
    
            if (textoBusca.length < 3) {
                return; // não busca com menos de 3 chars
            }
    
            const delayDebounce = setTimeout(() => {
                buscarInsumo(textoBusca);
            }, 500);
    
            return () => clearTimeout(delayDebounce);
    
        }, [textoBusca]);
    
        async function buscarInsumo(descricao) {
            try {
    
                const token = Cookies.get('token');
    
                const headers = {
                    'Authorization': 'Bearer ' + token
                };
    
                const response = await api.get(
                    `v1/protected/almoxarifado/estoque/listarporinsumosrapidopordescricao?descricao_busca=${descricao}`,
                    { headers }
                );
    
                setInsumos(response.data);
    
            } catch (err) {
                console.log("Erro ao listar informações: " + err);
            }
        }
    
    

    return (
        <div>
            <NavegadorGestao
                BaseDados={true}
                Propostas={true}
                corFundo={'white'} travado={true} corTexto={'black'}
            />
            {loading ?
                <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                </Skeleton>
                :

                <div >
                    <Grid container
                        alignItems="center"
                        justifyContent="center"
                    >


                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            align="center"
                            alignItems="center"
                            item xs={12}
                            style={{ margin: 10, fontSize: 14 }}
                        >
                            <span style={{ fontSize: 18, fontWeight: 'bold' }}>{"Proposta Nº " + idProposta + " "}</span>
                            <a

                                href={"/gestao/administracao/projetos/editaroprojeto/" + idProjeto + "/" + telaRetorno + "/" + idInstalacao + "/" + idCliente}
                                style={{ marginRight: 2, align: 'center', alignItems: 'center', fontSize: 12, color: 'black', marginRight: '5px' }}>
                                {" < Projeto " + idProjeto + returnDescricaoRetorno(instalacao)}
                            </a>

                        </Grid>





                        <Grid
                            item xs={12}
                            container
                            direction="row"
                            alignItems="center"
                            justifyContent={"center"}
                        >


                            <Box style={{ backgroundColor: 'white', width: '100%', alignItems: 'center', }}>
                                <AppBar position="static" >

                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        indicatorColor="secondary"
                                        textColor="inherit"
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        aria-label="scrollable auto tabs example"


                                    >
                                        <Tab label="Informações Iniciais" style={{ backgroundColor: '#1C1C1C', color: 'white' }} />
                                        <Tab label="Orçamentos" style={{ backgroundColor: '#1C1C1C', color: 'white' }} />
                                        <Tab label="A Proposta" style={{ backgroundColor: '#006400', color: 'white' }} /> {/* verde escuro */}
                                        <Tab label="Ordens de Serviços" style={{ backgroundColor: '#8B0000', color: 'white' }} /> {/* vermelho escuro */}
                                          <Tab label="Ordens de Compras" style={{ backgroundColor: '#6b14b3ff', color: 'white' }} /> {/* vermelho escuro */}

                                        <Tab label="Financeiro" style={{ backgroundColor: '#2F4F4F', color: 'white' }} /> {/* cinza escuro */}
                                        <Tab label="Documentos" style={{ backgroundColor: '#1E90FF', color: 'white' }} /> {/* azul dodger */}

                                    </Tabs>
                                </AppBar>

                            </Box>
                        </Grid>


                        <SwipeableViews
                            index={value}
                            onChangeIndex={handleChangeIndex}
                            style={{ backgroundColor: 'white', width: '100%', alignItems: 'center', }}
                        >

                            <Grid
                                value={value} index={0}
                                style={{ padding: 30 }}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="flex-start"
                                justifyContent="flex-start"
                                spacing={2}
                            >


                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    align="center"
                                    item xs={12} sm={12} md={12} lg={12} xl={12}
                                    style={{ marginTop: 5 }}
                                >
                                    <Grid
                                        container
                                        direction="column"
                                        justifyContent="center"
                                        align="center"
                                        item xs={6}
                                    >

                                        <Autocomplete
                                            id="select-ordem-solicitante"
                                            options={[]}
                                            disableCloseOnSelect
                                            getOptionLabel={(sol) => returnDescricaoSolicitante(sol).replace(/<br \/>/g, '\n')}
                                            value={proposta.usuario_criador}
                                            filterOptions={(options, { inputValue }) => {
                                                const inputKeywords = inputValue.toLowerCase().split(" ");
                                                return options.filter((solicitante) => {
                                                    const cotacaoText = returnDescricaoSolicitante(solicitante).toLowerCase();
                                                    return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                });
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Criador" multiline minRows={1} />
                                            )}
                                            renderOption={(option) => (
                                                <div dangerouslySetInnerHTML={{ __html: returnDescricaoSolicitante(option) }} />
                                            )}

                                        />
                                    </Grid>

                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="center"
                                        alignItems="center"
                                        item xs={12}
                                    >
                                        <span
                                            style={{
                                                padding: "5px 10px",
                                                border: "1px solid #ccc",
                                                borderRadius: "5px",
                                                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                                fontWeight: "bold",
                                                color: proposta.status_proposta === 3 ? "green" : proposta.status_proposta === 9 ? "red" : "inherit"

                                            }}
                                        >
                                            {returnDescricaoStatusProposta(proposta.status_proposta)}
                                        </span>

                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={(e) => handleOpenMudarStatus()}
                                            startIcon={<SwapHorizIcon />}
                                            style={{ margin: 10 }}
                                        >
                                        </Button>

                                    </Grid>
                                </Grid>




                                <Grid item xs={6}
                                    container
                                    alignItems="flex-start"
                                    justifyContent="flex-start"
                                >
                                    <Grid item xs={12}>
                                        <FormControl fullWidth>
                                            <InputLabel id="area-selector-label">Nível SLA</InputLabel>
                                            <Select
                                                labelId="area-selector-label"
                                                id="area-selector"
                                                value={nivelSla}

                                                label="Nível SLA"
                                            >
                                                <MenuItem value={0}>
                                                    Nível 0 - Básico     <br />
                                                    CAPITAL E REGIÃO METROPOLITANA EM ATÉ 48 HORAS <br />
                                                    INTERIOR DO ESTADO EM ATÉ 72 HORAS <br />
                                                    ÁREAS REMOTAS EM ATÉ 96 HORAS <br />
                                                    ----------------------------------------------

                                                </MenuItem>
                                                <MenuItem value={1}>
                                                    Nível 1 - Crítico     <br />
                                                    CAPITAL E REGIÃO METROPOLITANA	EM ATÉ 24 HORAS <br />
                                                    INTERIOR DO ESTADO	EM ATÉ 48 HORAS <br />
                                                    ÁREAS REMOTAS	EM ATÉ 72 HORAS <br />
                                                    ----------------------------------------------

                                                </MenuItem>

                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>


                               




                                <Grid
                                    container
                                    alignItems="flex-start"
                                    justifyContent="flex-start"
                                    item xs={4}
                                >
                                    <TextField
                                        variant="standard"
                                        name="diasValidade"
                                        label="Validade da Proposta (em dias)"
                                        required
                                        id="diasValidade"
                                        value={diasValidade}
                                        fullWidth
                                    />
                                </Grid>


                                <Grid
                                    container
                                    alignItems="flex-start"
                                    justifyContent="flex-start"
                                    item xs={4}
                                >
                                    <TextField
                                        variant="standard"
                                        name="data_prevista_inicio"
                                        label="Data Prevista para Ínicio da Instalação"
                                        required
                                        id="data_prevista_inicio"
                                        fullWidth

                                        type="text"
                                        value={formatarDataPtBr(dataPrevistaInicio)}
                                    />
                                </Grid>



                                <Grid
                                    container
                                    alignItems="flex-start"
                                    justifyContent="flex-start"
                                    item xs={4}
                                >
                                    <TextField
                                        variant="standard"
                                        name="data_prevista_conclusao"
                                        label="Data Prevista para Conclusão da Instalação"
                                        required
                                        type="text"
                                        value={formatarDataPtBr(dataPrevistaConclusao)}


                                        id="data_prevista_conclusao"
                                        fullWidth
                                    />
                                </Grid>


                                <Grid
                                    container
                                    alignItems="flex-start"
                                    justifyContent="flex-start"
                                    item xs={12}>
                                    <TextField
                                        variant="standard"
                                        name="descricaoProposta"
                                        label="Descrição Proposta"
                                        required
                                        id="descricaoProposta"
                                        value={descricaoProposta}
                                        fullWidth
                                        multiline
                                        minRows={1}
                                    />
                                </Grid>


 <Grid
                                    container
                                    alignItems="center"
                                    justifyContent="center"
                                    item xs={12}>

                                 <Grid item xs={4}
                                    container
                                    alignItems="center"
                                    justifyContent="center"
                                >

                                    <span style={{ fontSize: 16}}>{
                                        "Custo Previsto: " + currencyFormatter.format(proposta.valor_custo)}</span>

                                </Grid>

                                 <Grid item xs={4}
                                    container
                                    alignItems="center"
                                    justifyContent="center"
                                >

                                    <span style={{ fontSize: 16}}>{
                                        "Lucro Previsto: " + currencyFormatter.format(proposta.valor_lucro)}</span>

                                </Grid>

                                 <Grid item xs={4}
                                    container
                                    alignItems="center"
                                    justifyContent="center"
                                >

                                    <span style={{ fontSize: 16}}>{
                                        "Total Previsto: " + currencyFormatter.format(proposta.valor_custo + proposta.valor_lucro)}</span>

                                </Grid>
                                 </Grid>


                                 
 <Grid
                                    container
                                    alignItems="center"
                                    justifyContent="center"
                                    item xs={12}>

                                 <Grid item xs={4}
                                    container
                                    alignItems="center"
                                    justifyContent="center"
                                >

                                    <span style={{ fontSize: 16,  }}>{
                                        "Custo Real: " + currencyFormatter.format(0.0)}</span>

                                </Grid>

                                 <Grid item xs={4}
                                    container
                                    alignItems="center"
                                    justifyContent="center"
                                >

                                    <span style={{ fontSize: 16, }}>{
                                        "Lucro Real: " + currencyFormatter.format(0.0)}</span>

                                </Grid>

                                 <Grid item xs={4}
                                    container
                                    alignItems="center"
                                    justifyContent="center"
                                >

                                    <span style={{ fontSize: 16,  }}>{
                                        "Total: " + currencyFormatter.format(0.0)}</span>

                                </Grid>
                                 </Grid>


                            </Grid>
 <Grid
                                value={value} index={1}
                                style={{ padding: 10 }}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="center"
                                justifyContent="center"
                                spacing={2}
                            >
                              <Grid
                            item xs={12}
                            container
                            direction="row"
                            alignItems="center"
                            justifyContent={"center"}
                        >


                            <Box style={{ backgroundColor: 'white', width: '100%', alignItems: 'center', }}>
                                <AppBar position="static" >

                                    <Tabs
                                        value={valueOrcamentos}
                                        onChange={handleChangeOrcamentos}
                                        indicatorColor="secondary"
                                        textColor="inherit"
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        aria-label="scrollable auto tabs example"


                                    >
                                        <Tab label="DE INSUMOS" style={{ backgroundColor: '#1C1C1C', color: 'white' }} />
                                        <Tab label="DE OPERAÇÃO" style={{ backgroundColor: '#1C1C1C', color: 'white' }} />                                      
                                    </Tabs>
                                </AppBar>

                            </Box>
                        </Grid>


   <SwipeableViews
                            index={valueOrcamentos}
                            onChangeIndex={handleChangeIndexOrcamentos}
                            style={{ backgroundColor: 'white', width: '100%', alignItems: 'center', }}
                        >

                            <Grid value={valueOrcamentos} index={0}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="center"
                                justifyContent="center"
                                style={{ backgroundColor: 'white', width: '100%', alignItems: 'center', }}
                            >



                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="flex-start"
                                    item xs={12}
                                >
                                      <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="flex-start"
                                    item xs={3}
                                >
                                    <div {...getRootArquivoProps1()} style={dropzoneStyles}>
                                        <input {...getInputArquivoProps1()} />
                                        <Typography align="center" variant="h7">
                                            Anexo
                                        </Typography>
                                    </div>
                                    </Grid>

                                      <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-end"
                                    alignItems="flex-end"
                                    item xs={9}
                                >
                                          {!loading && (
    <>
        <Grid item>
           <Tooltip
  title={
   <Box>
  <div
    dangerouslySetInnerHTML={{
      __html:
        proposta?.taxas_individuais_insumos?.length > 0
          ? `<strong>Taxas aplicadas:</strong><br />` +
            proposta.taxas_individuais_insumos
              .map((taxa) => returnDescricaoTaxa(taxa))
              .join("<br /><br />")
          : 'Nenhuma taxa aplicada',
    }}
  />

  {proposta?.taxas_individuais_insumos?.length > 0 && (
    <Box mt={2} display="flex" alignItems="center">
      <Typography variant="body1" fontWeight="bold">
        Taxa Efetiva Final: {calcularTaxaEfetiva(proposta.taxas_individuais_insumos)}%
      </Typography>
      <Tooltip
        title={
          <div>
            <strong>O que é Taxa Efetiva?</strong>
            <br />
            A taxa efetiva representa o impacto acumulado de todas as taxas
            aplicadas (despesas e receitas) sobre o valor do item.
            <br />
            <br />
            Ela é calculada multiplicando os fatores de cada taxa:
            <br />
            (1 + taxa₁/100) × (1 + taxa₂/100) × ... × (1 + taxaₙ/100)
            <br />
            <br />
            Em seguida, subtrai-se 1 e multiplica-se por 100:
            <br />
            ((fator total - 1) × 100)
            <br />
            <br />
            <em>Exemplo:</em> 10% e 5% → (1.10 × 1.05 - 1) × 100 = 15.5%
          </div>
        }
        placement="right"
        arrow
         componentsProps={{
    tooltip: {
      sx: {
        maxWidth: 400,
        minWidth: 400,
        backgroundColor: '#ffffff',  // Fundo branco
        color: '#000000',            // Texto preto
        border: '1px solid #ddd',    // Borda leve (opcional)
        boxShadow: 3,                // Sombra leve (opcional)
        fontSize: '0.875rem',
      }
    }
  }}
      >
        <Typography
          variant="body2"
          sx={{
            ml: 1,
            color: 'primary.main',
            cursor: 'pointer',
            textDecoration: 'underline dotted',
          }}
        >
          [?]
        </Typography>
      </Tooltip>
    </Box>
  )}
</Box>
  }
  arrow
  placement="left"
  componentsProps={{
    tooltip: {
      sx: {
        maxWidth: 500,
        minWidth: 500,
        backgroundColor: '#ffffff',  // Fundo branco
        color: '#000000',            // Texto preto
        border: '1px solid #ddd',    // Borda leve (opcional)
        boxShadow: 3,                // Sombra leve (opcional)
        fontSize: '0.875rem',
      }
    }
  }}
>
  <InfoIcon color="action" style={{ cursor: 'pointer' }} />
</Tooltip>
        </Grid>

        <Grid item style={{paddingRight: 3}}>
            <Typography variant="body2">
             Taxas sobre insumos: {calcularTaxaEfetiva(proposta.taxas_individuais_insumos)}%
            </Typography>
        </Grid>

        <Grid item>
            <Button
                style={{ marginTop: 1 }}
                variant="contained"
                color="primary"
                onClick={handleOpenTaxasInsumos}
            >
                Taxas
            </Button>
        </Grid>

         <Grid item style={{ padding: 2 }}>
            <Button
                style={{ marginTop: 1}}
                variant="contained"
                color="primary"
                onClick={recalcular}
            >
                Recalcular
            </Button>
        </Grid>
    </>
)}
                                    </Grid>


                                </Grid>


                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    align="center"
                                    item xs={12}
                                    style={{ padding: 20 }}
                                >
                                    <Grid
                                        container
                                        direction="column"
                                        justifyContent="center"
                                        align="center"
                                        item xs={8}
                                    >

                                          <Autocomplete
                                                                                                               id="select-insumo"
                                                                                                               options={insumos}
                                                                                                               disableCloseOnSelect
                                                                                                               getOptionLabel={(insumo) =>
                                                                                                                   returnDescricaoInsumo(insumo).replace(/<br \/>/g, '\n')
                                                                                                               }
                                                                                                               value={insumoSelecionado}
                                                                                   
                                                                                                               onChange={(e, v) => handleSetInsumoSelecionado(v)}
                                                                                   
                                                                                                               // 🔥 captura O TEXTO DIGITADO
                                                                                                               onInputChange={(event, newInputValue) => {
                                                                                                                   setTextoBusca(newInputValue);
                                                                                                               }}
                                                                                   
                                                                                                               filterOptions={(options, { inputValue }) => {
                                                                                                                   const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                                                                   return options.filter((insumo) => {
                                                                                                                       const insumoText = returnDescricaoInsumo(insumo).toLowerCase();
                                                                                                                       return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                                                                                                   });
                                                                                                               }}
                                                                                   
                                                                                                               renderInput={(params) => (
                                                                                                                   <TextField {...params} label="Insumo" multiline minRows={2} />
                                                                                                               )}
                                                                                   
                                                                                                               renderOption={(option) => (
                                                                                                                   <div dangerouslySetInnerHTML={{ __html: returnDescricaoInsumo(option) }} />
                                                                                                               )}
                                                                                                           />
                                    </Grid>


                                    <Grid
                                        container
                                        item xs={2}
                                        justifyContent="center"
                                        alignItems="center"
                                        style={{ marginRight: 2 }}
                                    >
                                        <TextField
                                            variant="standard"
                                            name="quantidade"
                                            label="Quantidade"
                                            id="quantidade"
                                            value={quantidade}
                                            onChange={(e) => setQuantidade(e.target.value)}
                                            fullWidth
                                        />
                                    </Grid>

{temEstoque && (
     <Grid
        container
        item
        xs={6} // Aumenta o espaço para comportar o TextField e o Typography
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
    >
         <Grid item>
            <Typography variant="body2" color="textSecondary">
                {quantidadeNoEstoque} disponíveis
            </Typography>
        </Grid>
          <Grid item>
        <Typography variant="body2" color="textSecondary">
    Máx: {Math.min(quantidade, quantidadeNoEstoque)}
</Typography>
  </Grid>
                                     <Grid
                                        container
                                        item xs={4}
                                        justifyContent="center"
                                        alignItems="center"
                                        style={{ marginRight: 2 }}
                                    >
                                        <TextField
                                            variant="standard"
                                            name="quantidadeDoEstoque"
                                            label="Quantidade do Estoque"
                                            id="quantidadeDoEstoque"
                                            value={quantidadeDoEstoque}
 inputProps={{
        type: "number",
        min: 0,
        max: Math.min(quantidade, quantidadeNoEstoque)
    }}                                            onChange={(e) => handleSetQuantidadeDoEstoque(e.target.value)}
                                            fullWidth
                                        />
                                    </Grid>
                                      </Grid>
)}


                                    <Grid
                                        container
                                        item xs={12}
                                        justifyContent="center"
                                        alignItems="center"
                                        style={{ paddingTop: 10 }}
                                    >
                                        <TextField
                                            variant="standard"
                                            name="observacoesItem"
                                            label="Observações"
                                            id="observacoesItem"
                                            value={observacoesItem}
                                            onChange={(e) => setObservacoesItem(e.target.value)}
                                            fullWidth
                                            multiline
                                            minRows={1}
                                        />
                                    </Grid>

                                    <Grid
                                        container
                                        item xs={9}
                                        justifyContent="center"
                                        alignItems="center"
                                        style={{ paddingTop: 10 }}
                                    >
                                        <TextField
                                            variant="standard"
                                            name="descricaoNovoInsumo"
                                            label="Descrição para Novo Insumo"
                                            id="descricaoNovoInsumo"
                                            value={descricaoNovoInsumo}
                                            onChange={(e) => setDescricaoNovoInsumo(e.target.value)}
                                            fullWidth
                                            multiline
                                            minRows={1}
                                        />
                                    </Grid>
  <Grid
                                        container
                                        item xs={3}
                                        justifyContent="center"
                                        alignItems="center"
                                        style={{ paddingTop: 10 }}
                                    >
                                     <Tooltip
      title="Ao marcar a opção 'Discriminar a parte', o insumo é descrito à parte na proposta final."
      placement="right"
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 8],
              },
            },
          ],
        },
      }}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: '#ffffff',
            color: '#000000',
            fontSize: '0.875rem',
            border: '1px solid #ccc',
            boxShadow: 3,
          },
        },
      }}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={descreverSeparadamente}
            onChange={handleChangeDescrever}
            color="primary"
          />
        }
        label="Discriminar a parte"
      />
    </Tooltip>
</Grid>

                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="center"
                                        alignItems="center"
                                        item xs={2}
                                    >
                                        <Button style={{ marginTop: 5 }}
                                            variant="contained"
                                            color="primary"
                                            onClick={(ev) => adicionarItem()}
                                        > Adicionar Item  </Button>
                                    </Grid>





                                </Grid>







                                <Grid
                                    style={{ paddingTop: 1 }}
                                    container
                                    direction="row"
                                    item xs={12}
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    <Grid
                                        style={{ paddingTop: 1 }}
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                          <Grid
                                        style={{ paddingTop: 0 }}
                                        container
                                        direction="row"
                                        item xs={11}
                                        alignItems="flex-end"
                                        justifyContent="flex-end"
                                    >
     <Box display="flex" justifyContent="center">
      {/* Bloco: Custo Previsto */}
      <Tooltip
        title={
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              border: '1px solid #ccc',
              boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.2)',
              fontSize: 13,
              padding: 1,
            }}
          >
            Custo Previsto é o valor de custo do item adicionado às taxas do tipo despesa
          </Box>
        }
        placement="top"
        arrow
      >
        <Box textAlign="center">
          <Typography variant="body2" color="text.primary">
            Custo Previsto
          </Typography>
          <Typography variant="h6" fontWeight="bold">
            {valorTotalCustoPrevisto.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </Typography>
        </Box>
      </Tooltip>

      {/* Bloco: Lucro Previsto */}
      <Tooltip
        title={
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              border: '1px solid #ccc',
              boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.2)',
              fontSize: 13,
              padding: 1,
            }}
          >
            Lucro Previsto é o valor de custo do item adicionado às taxas do tipo receita
          </Box>
        }
        placement="top"
        arrow
      >
        <Box textAlign="center" mx={espacamentoEntreBlocos}>
          <Typography variant="body2" color="text.primary">
            Lucro Previsto
          </Typography>
          <Typography variant="h6" fontWeight="bold">
            {valorTotalLucroPrevisto.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </Typography>
        </Box>
      </Tooltip>

      {/* Bloco: Total Previsto */}
      <Tooltip
        title={
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              border: '1px solid #ccc',
              boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.2)',
              fontSize: 13,
              padding: 1,
            }}
          >
            Total Previsto é o valor do item adicionado a todas as taxas
          </Box>
        }
        placement="top"
        arrow
      >
        <Box textAlign="center" mx={espacamentoEntreBlocos}>
          <Typography variant="body2" color="text.primary">
            Total Previsto
          </Typography>
          <Typography variant="h6" fontWeight="bold">
            {valorTotalPrevisto.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </Typography>
        </Box>
      </Tooltip>
    </Box>

     <Tooltip title="Atualizar item referente a insumos na proposta">
  <IconButton size="small" color="primary" onClick={(e) => handleClickAtualizarInsumosNaProposta()}>
    <UpdateIcon />
  </IconButton>
</Tooltip>
   </Grid>

                                    </Grid>
                                    {
                                        itensRequerimento &&
                                        <>
                                        <Box sx={{ height: 800, width: '100%', overflow: 'auto',overflowX: 'auto' }}>

                                            <DataGrid
                                                pagination
                                                checkboxSelection
                                                rows={itensRequerimento}
                                                getRowId={(row) => row.id_item_requerimento}
                                                columns={colunasInsumos}
                                                disableColumnResize={false}

                                                onRowSelectionModelChange={handleSelectionChange}
                                               

                                                onCellClick={handleCellClick}
                                                onRowClick={handleRowClick}
                                               slots={{
    toolbar: CustomToolbar,
  }}
   sx={{
    height: 600, // altura fixa ativa o cabeçalho fixo
  }}
   pinnedColumns={{
    left: ['insumo'], // fixa a coluna "descricao" à esquerda
  }}
                                            />
</Box>

                                        </>
                                    }



                                </Grid>



                            </Grid>

                                 <Grid
                                value={value} index={1}
                                style={{ padding: 10 }}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="center"
                                justifyContent="center"
                                spacing={2}
                            >

                                      <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-end"
                                    alignItems="flex-end"
                                    item xs={12}
                                >
                                          {!loading && (
    <>
        <Grid item>
           <Tooltip
  title={
   <Box>
  <div
    dangerouslySetInnerHTML={{
      __html:
        proposta?.taxas_operacao?.length > 0
          ? `<strong>Taxas aplicadas:</strong><br />` +
            proposta.taxas_operacao
              .map((taxa) => returnDescricaoTaxa(taxa))
              .join("<br /><br />")
          : 'Nenhuma taxa aplicada',
    }}
  />

  {proposta?.taxas_operacao?.length > 0 && (
    <Box mt={2} display="flex" alignItems="center">
      <Typography variant="body1" fontWeight="bold">
        Taxa Efetiva Final: {calcularTaxaEfetiva(proposta.taxas_operacao)}%
      </Typography>
      <Tooltip
        title={
          <div>
            <strong>O que é Taxa Efetiva?</strong>
            <br />
            A taxa efetiva representa o impacto acumulado de todas as taxas
            aplicadas (despesas e receitas) sobre o valor do item.
            <br />
            <br />
            Ela é calculada multiplicando os fatores de cada taxa:
            <br />
            (1 + taxa₁/100) × (1 + taxa₂/100) × ... × (1 + taxaₙ/100)
            <br />
            <br />
            Em seguida, subtrai-se 1 e multiplica-se por 100:
            <br />
            ((fator total - 1) × 100)
            <br />
            <br />
            <em>Exemplo:</em> 10% e 5% → (1.10 × 1.05 - 1) × 100 = 15.5%
          </div>
        }
        placement="right"
        arrow
         componentsProps={{
    tooltip: {
      sx: {
        maxWidth: 400,
        minWidth: 400,
        backgroundColor: '#ffffff',  // Fundo branco
        color: '#000000',            // Texto preto
        border: '1px solid #ddd',    // Borda leve (opcional)
        boxShadow: 3,                // Sombra leve (opcional)
        fontSize: '0.875rem',
      }
    }
  }}
      >
        <Typography
          variant="body2"
          sx={{
            ml: 1,
            color: 'primary.main',
            cursor: 'pointer',
            textDecoration: 'underline dotted',
          }}
        >
          [?]
        </Typography>
      </Tooltip>
    </Box>
  )}
</Box>
  }
  arrow
  placement="left"
  componentsProps={{
    tooltip: {
      sx: {
        maxWidth: 500,
        minWidth: 500,
        backgroundColor: '#ffffff',  // Fundo branco
        color: '#000000',            // Texto preto
        border: '1px solid #ddd',    // Borda leve (opcional)
        boxShadow: 3,                // Sombra leve (opcional)
        fontSize: '0.875rem',
      }
    }
  }}
>
  <InfoIcon color="action" style={{ cursor: 'pointer' }} />
</Tooltip>
        </Grid>

        <Grid item style={{paddingRight: 3}}>
            <Typography variant="body2">
             Taxas sobre custos operacionais: {calcularTaxaEfetiva(proposta.taxas_operacao)}%
            </Typography>
        </Grid>

        <Grid item>
            <Button
                style={{ marginTop: 1 }}
                variant="contained"
                color="primary"
                onClick={handleOpenTaxasOperacionais}
            >
                Taxas
            </Button>
        </Grid>

         <Grid item style={{ padding: 2 }}>
            <Button
                style={{ marginTop: 1}}
                variant="contained"
                color="primary"
                onClick={recalcularTaxasOperacionais}
            >
                Recalcular
            </Button>
        </Grid>
    </>
)}
                                    </Grid>

                                    <Grid
                                        style={{ paddingTop: 1 }}
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                          <Grid
                                        style={{ paddingTop: 0 }}
                                        container
                                        direction="row"
                                        item xs={11}
                                        alignItems="flex-end"
                                        justifyContent="flex-end"
                                    >
     <Box display="flex" justifyContent="center">
      {/* Bloco: Custo Previsto */}
      <Tooltip
        title={
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              border: '1px solid #ccc',
              boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.2)',
              fontSize: 13,
              padding: 1,
            }}
          >
            Custo Operacional Previsto é o valor total de custos operacionais adicionados a taxas operacionais do tipo despesa
          </Box>
        }
        placement="top"
        arrow
      >
        <Box textAlign="center">
          <Typography variant="body2" color="text.primary">
            Custo Operacional
          </Typography>
          <Typography variant="h6" fontWeight="bold">
            {valorTotalCustoCOPrevisto.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </Typography>
        </Box>
      </Tooltip>

      {/* Bloco: Lucro Previsto */}
      <Tooltip
        title={
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              border: '1px solid #ccc',
              boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.2)',
              fontSize: 13,
              padding: 1,
            }}
          >
            Lucro Operacional Previsto é o valor de custos operacionais adicionados as taxas operacionais do tipo receita
          </Box>
        }
        placement="top"
        arrow
      >
        <Box textAlign="center" mx={espacamentoEntreBlocos}>
          <Typography variant="body2" color="text.primary">
            Lucro Operacional Previsto
          </Typography>
          <Typography variant="h6" fontWeight="bold">
            {valorTotalLucroCOPrevisto.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </Typography>
        </Box>
      </Tooltip>

      {/* Bloco: Total Previsto */}
      <Tooltip
        title={
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              border: '1px solid #ccc',
              boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.2)',
              fontSize: 13,
              padding: 1,
            }}
          >
            Total Operacional Previsto é o valor dos custos operacionais adicionados a todas as taxas operacionais
          </Box>
        }
        placement="top"
        arrow
      >
        <Box textAlign="center" mx={espacamentoEntreBlocos}>
          <Typography variant="body2" color="text.primary">
            Total Previsto
          </Typography>
          <Typography variant="h6" fontWeight="bold">
            {valorTotalPrevistoCO.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </Typography>
        </Box>
      </Tooltip>
    </Box>

     <Tooltip title="Atualizar item referente a Custos Operacionais na proposta">
  <IconButton size="small" color="primary" onClick={(e) => handleClickAtualizarMaoDeObraNaProposta()}>
    <UpdateIcon />
  </IconButton>
</Tooltip>
   </Grid>
 </Grid>

   <Grid
                                        container
                                        direction="row"
                                        justifyContent="flex-end"
                                        alignItems="flex-end"
                                        item xs={12}
                                        spacing={2}
                                        style={{ paddingTop: 1 }}
                                    >
 {custosOperacionaisSelecionados && Object.keys(custosOperacionaisSelecionados).length > 0 && <Grid
                    container
                    direction="row"
                    alignItems="flex-end"
                    justifyContent="flex-end"
                    item xs={3}
                >
                    <ColorButtonRed variant="outlined" color="secondary"
                        onClick={handleClickRemoverCustosOperacionaisSelecionados}
                    >
                        Remover Selecionados
                    </ColorButtonRed>
 </Grid>
                                 
 }
                         </Grid>      
                                {custosOperacionais !== null && (



                                    <MaterialReactTable

                                        columns={colunasCustosOperacionais}
                                        data={custosOperacionais}
                                        enableTopToolbar={false}
                                        enableBottomToolbar={false}
                                        enablePagination={false}
                                        enableColumnFilters={false}
                                        enableColumnActions={false}
                                        sortable={false}
                                        enableRowActions={true}
                                        enableSorting={false}
                                        enableRowSelection={true}
                                        onRowSelectionChange={handleCustosOperacionaisSelecionados}
                                        color={'black'}
                                        state={{ rowSelection: custosOperacionaisSelecionados }}
                                        paginationDisplayMode={'pages'}
                                        getRowId={(row) => row.id_custo_operacao}
                                        initialState={{
                                            pagination: { pageSize: 20, pageIndex: 0 },
                                            showGlobalFilter: true,
                                            color: 'black'
                                        }}
                                        muiTableContainerProps={{ sx: { maxHeight: "3000px", color: 'black' } }}
                                        muiTableBodyRowProps={{
                                            sx: {
                                                height: 35,
                                                color: 'black' // Define a cor do texto para preto
                                            },
                                        }}
                                        enableColumnFilterModes={false}
                                        enableExpandAll={true}
                                        enableColumnPinning={true}
                                        enableColumnResizing={true}
                                        muiPaginationProps={{
                                            rowsPerPageOptions: [20, 50, 100],
                                            variant: 'outlined',
                                        }}
                                        enableFullScreenToggle={true}
                                        muiTablePaperProps={({ table }) => ({
                                            style: {
                                                zIndex: table.getState().isFullScreen ? 1000 : undefined,
                                                color: 'black',
                                            },
                                        })}

                                        renderRowActionMenuItems={({ row, table }) => [

                                            <Tooltip title="Deletar">
                                                <IconButton size="small" color="error" onClick={() => handleClickRemoverCustoOperacional(row.original)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Tooltip>
                                        ]}


                                    />


                                )}

                                <Paper
                                    elevation={5} // Ajuste o valor da elevação conforme necessário
                                    style={{
                                        backgroundColor: '#edf2f9', // Ajuste a cor de fundo conforme necessário
                                        padding: 20,
                                        borderRadius: 10, // Adiciona bordas levemente arredondadas
                                        boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.2)', // Ajusta os valores da sombra conforme necessário
                                        margin: '20px', // Ajusta a margem para afastamento das bordas da tela
                                    }}
                                >
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="center"
                                        alignItems="center"
                                        item xs={12}
                                        spacing={2}
                                        style={{ paddingTop: 20 }}
                                    >

                                       
                                        <Grid
                                        container
                                        direction="column"
                                        justifyContent="center"
                                        align="center"
                                        item xs={12}
                                    >

                                        <Autocomplete
                                            id="select-servico"
                                            options={servicosOperacionais}
                                            getOptionLabel={(servico) => returnDescricaoServicoOperacional(servico).replace(/<br \/>/g, '\n')}
                                            value={servicoOperacionalSelecionado}
                                            getOptionSelected={(option, value) => true}
                                            onChange={(e, v) => handleServicoOperacionalSelecionado(v)}
                                            filterOptions={(options, { inputValue }) => {
                                                const inputKeywords = inputValue.toLowerCase().split(" ");
                                                return options.filter((insumo) => {
                                                    const insumoText = returnDescricaoServicoOperacional(insumo).toLowerCase();
                                                    return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                                });
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} label=" Serviço Operacional " multiline minRows={2} />
                                            )}
                                            renderOption={(option) => (
                                                <div dangerouslySetInnerHTML={{ __html: returnDescricaoServicoOperacional(option) }} />
                                            )}
                                        />
                                    </Grid>
                                       
                                        <Grid item xs={9}>
                                            <TextField
                                                variant="standard"
                                                name="descricaoItem"
                                                label="Descrição"
                                                required
                                                id="descricaoItem"
                                                value={descricaoItemCO}
                                                onChange={(e) => setDescricaoItemCO(e.target.value)}
                                                fullWidth
                                                multiline
                                                minRows={1}
                                            />
                                        </Grid>

                                          <Grid
                                        container
                                        item xs={3}
                                        justifyContent="center"
                                        alignItems="center"
                                        style={{ paddingTop: 10 }}
                                    >
                                     <Tooltip
      title="Ao marcar a opção 'Discriminar a parte', o Custo Operacionall é descrito à parte na proposta final."
      placement="right"
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 8],
              },
            },
          ],
        },
      }}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: '#ffffff',
            color: '#000000',
            fontSize: '0.875rem',
            border: '1px solid #ccc',
            boxShadow: 3,
          },
        },
      }}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={descreverSeparadamenteCO}
            onChange={handleChangeDescreverCO}
            color="primary"
          />
        }
        label="Discriminar a parte"
      />
    </Tooltip>
</Grid>

                                      <Grid item xs={2}>
  <FormControl variant="standard" fullWidth required>
    <InputLabel id="unidade-label">Unidade</InputLabel>
    <Select
      labelId="unidade-label"
      id="unidadeItem"
      name="unidadeItem"
      value={unidadeItemCO}
      onChange={(e) => setUnidadeItemCO(e.target.value)}
    >
      {unidades.map((item) => (
        <MenuItem key={item} value={item}>
          {item}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>


                                        <Grid item xs={2}>
                                            <TextField
                                                variant="standard"
                                                name="quantidadeItem"
                                                label="Quantidade"
                                                required
                                                id="quantidadeItem"
                                                value={quantidadeItemCO}
onChange={(e) => {
  const valor = e.target.value
    .replace(/[^0-9.]/g, '')      // permite apenas números e ponto
    .replace(/^(\d*\.\d*).*$/, '$1'); // impede múltiplos pontos
  handleQuantidadeItemCO(valor);
}}                                                fullWidth
                                            />
                                        </Grid>

                                        <Grid item xs={2}>
                                            <TextField
                                                variant="standard"
                                                name="quantidadeTotal"
                                                label="Periodo"
                                                required
                                                id="quantidadeTotal"
                                                value={periodoCO}
                                             onChange={(e) => handlePeriodoCO(e.target.value.replace(/^(\D*)(\d*(?:\.\d{0,2})?).*$/, '$2'))}

                                               
                                                fullWidth
                                            />
                                        </Grid>

                                       <Grid item xs={2}>
  <FormControl variant="standard" fullWidth required>
    <InputLabel id="periodicidade-label">Periodicidade</InputLabel>
    <Select
      labelId="periodicidade-label"
      id="periodicidade"
      name="periodicidade"
      value={periodicidadeCO}
      onChange={(e) => setPeriodicidadeCO(e.target.value)}
    >
      {periodicidades.map((item) => (
        <MenuItem key={item} value={item}>
          {item.charAt(0) + item.slice(1).toLowerCase()}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>


                                        <Grid item xs={2}>
                                            <TextField
                                                variant="standard"
                                                name="valorUnitario"
                                                label="Valor Unitário"
                                                required
                                                id="valorUnitario"
                                                value={valorUnitarioCO}
                                                onChange={(e) => handleSetValorUnitarioCO(e.target.value.replace(/^(\D*)(\d*(?:\.\d{0,2})?).*$/, '$2'))}
                                                fullWidth
                                            />
                                        </Grid>

                                         



                                    </Grid>
                                </Paper>


                                                                                   <Grid
                                                                                   container
                                                                                   direction="row"
                                                                                   justifyContent="center"
                                                                                   align="center"
                                                                                   item xs={11}
                                                                                   spacing={2}
                                                                                   style={{ marginTop: 3 }}
            
            >
                  <Grid item xs={3}>
                                            <TextField
                                                variant="standard"
                                                name="valorUnitarioCO"
                                                label="Custo Unitário sem taxas"
                                                required
                                                id="valorUnitarioCO"
                                                value={valorUnitarioCO}
                                                fullWidth
                                            />
                                        </Grid>

                  <Grid item xs={3}>
                                            <TextField
                                                variant="standard"
                                                name="valorTaxadoDespesaCO"
                                                label="Custo Unitário com taxas"
                                                required
                                                id="valorTaxadoDespesaCO"
                                                value={valorTaxadoDespesaCO}
                                                onChange={(e) => setValorTaxadoDespesaCO(e.target.value.replace(/^(\D*)(\d*(?:\.\d{0,2})?).*$/, '$2'))}
                                                fullWidth
                                            />
                                        </Grid>

                                        <Grid item xs={3}>
  <TextField
    variant="standard"
    name="valorTaxadoReceitaCO"
    label="Lucro Unitário com taxas"
    required
    id="valorTaxadoReceitaCO"
    value={valorTaxadoReceitaCO}
    onChange={(e) => {
      const valor = e.target.value;
      const match = valor.match(/^(-?\d*\.?\d{0,2})/);
      setValorTaxadoReceitaCO(match ? match[1] : '');
    }}
    fullWidth
  />
</Grid>


   <Grid item xs={3}>
                                            <TextField
                                                variant="standard"
                                                name="valorTaxadoCO"
                                                label="Valor Unitário Final com taxas"
                                                required
                                                id="valorTaxadoCO"
                                                value={valorTaxadoCO}
                                                onChange={(e) => setValorTaxadoCO(e.target.value.replace(/^(\D*)(\d*(?:\.\d{0,2})?).*$/, '$2'))}
                                                fullWidth
                                            />
                                        </Grid>
                                    </Grid>



                                    
                                                                                   <Grid
                                                                                   container
                                                                                   direction="row"
                                                                                   justifyContent="center"
                                                                                   align="center"
                                                                                   item xs={11}
                                                                                   spacing={2}
                                                                                   style={{ marginTop: 3 }}
            
            >

                   <Grid item xs={3}>
                                            <TextField
                                                variant="standard"
                                                name="valorTotalCO"
                                                label="Custo Total sem taxas"
                                                required
                                                id="valorTotalCO"
                                                value={valorTotalCO}
                                                onChange={(e) => setValorTotalCO(e.target.value.replace(/^(\D*)(\d*(?:\.\d{0,2})?).*$/, '$2'))}
                                                fullWidth
                                            />
                                        </Grid>

                  <Grid item xs={3}>
                                            <TextField
                                                variant="standard"
                                                name="valorTotalTaxadoDespesaCO"
                                                label="Custo Total com taxas"
                                                required
                                                id="valorTotalTaxadoDespesaCO"
                                                value={valorTotalTaxadoDespesaCO}
                                                onChange={(e) => setValorTotalTaxadoDespesaCO(e.target.value.replace(/^(\D*)(\d*(?:\.\d{0,2})?).*$/, '$2'))}
                                                fullWidth
                                            />
                                        </Grid>

                                        <Grid item xs={3}>
  <TextField
    variant="standard"
    name="valorTotalTaxadoReceitaCO"
    label="Lucro Total com taxas"
    required
    id="valorTotalTaxadoReceitaCO"
    value={valorTotalTaxadoReceitaCO}
    onChange={(e) => {
      const valor = e.target.value;
      const match = valor.match(/^(-?\d*\.?\d{0,2})/);
      setValorTotalTaxadoReceitaCO(match ? match[1] : '');
    }}
    fullWidth
  />
</Grid>


   <Grid item xs={3}>
                                            <TextField
                                                variant="standard"
                                                name="valorTotalTaxadoCO"
                                                label="Valor Total Final com taxas"
                                                required
                                                id="valorTotalTaxadoCO"
                                                value={valorTotalTaxadoCO}
                                                onChange={(e) => setValorTotalTaxadoCO(e.target.value.replace(/^(\D*)(\d*(?:\.\d{0,2})?).*$/, '$2'))}
                                                fullWidth
                                            />
                                        </Grid>
                                    </Grid>

                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-end"
                                    alignItems="center"
                                    item xs={12}
                                >
                                    <Button style={{ marginTop: 20 }}
                                        variant="contained"
                                        color="primary"
                                        onClick={novoCustoOperacional}
                                    >
                                        Adicionar Custo Operacional
                                    </Button>
                                </Grid>

</Grid>

                                 </SwipeableViews>

 </Grid>
                            <Grid
                                value={value} index={2}
                                style={{ padding: 10 }}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="center"
                                justifyContent="center"
                                spacing={2}
                            >




                                {itens !== null && (



                                    <MaterialReactTable

                                        columns={colunas}
                                        data={itens}
                                        enableTopToolbar={false}
                                        enableBottomToolbar={false}
                                        enablePagination={false}
                                        enableColumnFilters={false}
                                        enableColumnActions={false}
                                        sortable={false}
                                        enableRowActions={true}
                                        enableSorting={false}
                                        enableRowSelection={false}
                                        color={'black'}
                                        paginationDisplayMode={'pages'}
                                        getRowId={(row) => row.id_item_analise}
                                        initialState={{
                                            pagination: { pageSize: 20, pageIndex: 0 },
                                            showGlobalFilter: true,
                                            color: 'black'
                                        }}
                                        muiTableContainerProps={{ sx: { maxHeight: "3000px", color: 'black' } }}
                                        muiTableBodyRowProps={{
                                            sx: {
                                                height: 55,
                                                color: 'black' // Define a cor do texto para preto
                                            },
                                        }}
                                        enableColumnFilterModes={false}
                                        enableExpandAll={true}
                                        enableColumnPinning={true}
                                        enableColumnResizing={true}
                                        muiPaginationProps={{
                                            rowsPerPageOptions: [20, 50, 100],
                                            variant: 'outlined',
                                        }}
                                        enableFullScreenToggle={true}
                                        muiTablePaperProps={({ table }) => ({
                                            style: {
                                                zIndex: table.getState().isFullScreen ? 1000 : undefined,
                                                color: 'black',
                                            },
                                        })}

                                        renderRowActionMenuItems={({ row, table }) => [

                                            <Tooltip title="Deletar">
                                                <IconButton size="small" color="error" onClick={() => handleClickRemocao(row.original)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Tooltip>
                                        ]}


                                    />


                                )}

                                <Paper
                                    elevation={5} // Ajuste o valor da elevação conforme necessário
                                    style={{
                                        backgroundColor: '#edf2f9', // Ajuste a cor de fundo conforme necessário
                                        padding: 20,
                                        borderRadius: 10, // Adiciona bordas levemente arredondadas
                                        boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.2)', // Ajusta os valores da sombra conforme necessário
                                        margin: '20px', // Ajusta a margem para afastamento das bordas da tela
                                    }}
                                >
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="center"
                                        alignItems="center"
                                        item xs={12}
                                        spacing={2}
                                        style={{ paddingTop: 20 }}
                                    >

                                        <Grid item xs={12}>
                                            <TextField
                                                variant="standard"
                                                name="descricaoItem"
                                                label="Descrição"
                                                required
                                                id="descricaoItem"
                                                value={descricaoItem}
                                                onChange={(e) => setDescricaoItem(e.target.value)}
                                                fullWidth
                                                multiline
                                                minRows={1}
                                            />
                                        </Grid>

                                        <Grid item xs={2}>
                                            <TextField
                                                variant="standard"
                                                name="unidadeItem"
                                                label="Unidade"
                                                required
                                                id="unidadeItem"
                                                value={unidadeItem}
                                                onChange={(e) => setUnidadeItem(e.target.value)}
                                                fullWidth
                                            />
                                        </Grid>

                                        <Grid item xs={2}>
                                            <TextField
                                                variant="standard"
                                                name="quantidadeItem"
                                                label="Quantidade"
                                                required
                                                id="quantidadeItem"
                                                value={quantidadeItem}
                                                onChange={(e) => setQuantidadeItem(e.target.value.replace(/\D/g, ''))}
                                                fullWidth
                                            />
                                        </Grid>

                                        <Grid item xs={2}>
                                            <TextField
                                                variant="standard"
                                                name="quantidadeTotal"
                                                label="Quantidade Total"
                                                required
                                                id="quantidadeTotal"
                                                value={quantidadeTotal}
                                                onChange={(e) => setQuantidadeTotal(e.target.value.replace(/\D/g, ''))}
                                                fullWidth
                                            />
                                        </Grid>

                                        <Grid item xs={2}>
                                            <TextField
                                                variant="standard"
                                                name="periodicidade"
                                                label="Periodicidade"
                                                required
                                                id="periodicidade"
                                                value={periodicidade}
                                                onChange={(e) => setPeriodicidade(e.target.value)}
                                                fullWidth
                                            />
                                        </Grid>


                                        <Grid item xs={2}>
                                            <TextField
                                                variant="standard"
                                                name="valorUnitario"
                                                label="Valor Unitário"
                                                required
                                                id="valorUnitario"
                                                value={valorUnitario}
                                                onChange={(e) => setValorUnitario(e.target.value.replace(/^(\D*)(\d*(?:\.\d{0,2})?).*$/, '$2'))}
                                                fullWidth
                                            />
                                        </Grid>

                                        <Grid item xs={2}>
                                            <TextField
                                                variant="standard"
                                                name="valorTotal"
                                                label="Valor Total"
                                                required
                                                id="valorTotal"
                                                value={valorTotal}
                                                onChange={(e) => setValorTotal(e.target.value.replace(/^(\D*)(\d*(?:\.\d{0,2})?).*$/, '$2'))}
                                                fullWidth
                                            />
                                        </Grid>



                                    </Grid>
                                </Paper>


                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-end"
                                    alignItems="center"
                                    item xs={12}
                                >
                                    <Button style={{ marginTop: 20 }}
                                        variant="contained"
                                        color="primary"
                                        onClick={novoItem}
                                    >
                                        Adicionar Serviço
                                    </Button>
                                </Grid>


                            </Grid >


                            

                            <Grid value={value} index={3}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="center"
                                justifyContent="center"
                                style={{ backgroundColor: 'white', width: '100%', alignItems: 'center', }}
                            >

                                <div style={{ paddingTop: 5, paddingLeft: 220, width: '100%', backroungcolor: '#f0f4f4' }}>
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="flex-end"
                                        alignItems="center"
                                        item xs={12}
                                    >
                                        <Button style={{ margin: 5 }}
                                            variant="contained"
                                            color="primary"
                                            onClick={novaOS}
                                        >
                                            Nova Ordem de Serviço
                                        </Button>
                                    </Grid>

                                    {loading ?
                                        <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                                        </Skeleton>
                                        :

                                        <div>
                                            <div style={{ backgroundColor: 'white', margin: 5 }}>
                                                {ordensServicos && (
                                                    <MaterialReactTable
                                                        columns={columns}
                                                        data={ordensServicos}
                                                        enableBottomToolbar={true}
                                                        enableGlobalFilterModes
                                                        enablePagination={true}
                                                        enableRowActions
                                                        paginationDisplayMode={'pages'}
                                                        getRowId={(row) => row.id_ordem_servico}
                                                        enableGrouping
                                                        initialState={{
                                                            pagination: { pageSize: 50, pageIndex: 0 }, // Correção da sintaxe 
                                                            showGlobalFilter: true,
                                                        }}
                                                        muiTableContainerProps={{ sx: { maxHeight: "1000px" } }}

                                                        muiPaginationProps={{
                                                            rowsPerPageOptions: [50, 100, 200],
                                                            variant: 'outlined',
                                                        }}
                                                        enableFullScreenToggle={true}
                                                        renderDetailPanel={({ row }) => (
                                                            <Box
                                                                sx={{
                                                                    alignItems: 'center',
                                                                    display: 'flex',
                                                                    justifyContent: 'space-around',
                                                                    left: '30px',
                                                                    maxWidth: '1000px',
                                                                    position: 'sticky',
                                                                    width: '100%',
                                                                }}
                                                            >
                                                            </Box>
                                                        )}
                                                        renderRowActions={({ row }) => (
                                                            <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'row', alignItems: 'center' }}>
                                                                {
                                                                    parseInt(row.original.status_ordem) > 0 &&
                                                                    <Tooltip title="Gerenciar">
                                                                        <IconButton
                                                                            onClick={() => handleClickEdicao(row.original)}
                                                                        >
                                                                            <EditIcon style={{ color: 'green' }} />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                }
                                                                {
                                                                    parseInt(row.original.status_ordem) === 0 &&
                                                                    <Tooltip title="Designar Analista">
                                                                        <IconButton color="error"  >
                                                                            <SettingsIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                }


                                                            </Box>
                                                        )}

                                                    />
                                                )}
                                            </div>
                                        </div>

                                    }


                                </div>

                            </Grid>

                             <Grid value={value} index={4}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="center"
                                justifyContent="center"
                                style={{ backgroundColor: 'white', width: '100%', alignItems: 'center', }}
                            >
                                  <Box
                                                                    sx={{
                                                                        width: '100%',
                                                                        maxWidth: 1200, // define o limite da tabela
                                                                        padding: 2,     // padding interno
                                                                        boxSizing: 'border-box',
                                                                    }}
                                                                >
                                    <OrdemComprasComponent  idColaborador={0} idProposta={idProposta} />
 </Box>
                                </Grid>


                            <Grid value={value} index={5}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="center"
                                justifyContent="center"
                                style={{ backgroundColor: 'white', width: '100%', alignItems: 'center', }}
                            >

                                <div style={{ paddingTop: 5, paddingLeft: 220 }}>
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="flex-end"
                                        alignItems="center"
                                        item xs={12}
                                    >
                                        <Button style={{ margin: 5 }}
                                            variant="contained"
                                            color="primary"
                                            onClick={novoLancamento}
                                        >
                                            Novo Lançamento
                                        </Button>
                                    </Grid>

                                    {loading ?
                                        <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                                        </Skeleton>
                                        :

                                        <div>
                                            <DataGrid
                                                rows={lancamentos}
                                                getRowId={(row) => row.id_lancamento}
                                                columns={columnsLancamentos}
                                                disableColumnResize={false}
                                                autoHeight
                                                onCellClick={handleCellClick}
                                                onRowClick={handleRowClick}
                                                components={{
                                                    Toolbar: CustomToolbar,
                                                }}
                                            />
                                        </div>
                                    }


                                </div>
                            </Grid>



                        </SwipeableViews >







                    </Grid >


                </div >
            }



            <Dialog open={openMudarStatus} onClose={handleCloseMudarStatus} PaperProps={{ style: { maxWidth: '1000px', minWidth: '500px' } }}>
                <DialogTitle>MudarStatus</DialogTitle>
                <DialogContent>
                    <Grid
                        direction={"row"}
                        item xs={12}
                        container
                        alignItems={'center'}
                        justifyContent={'center'}
                        spacing={1}
                    >

                        <Grid item xs={12}
                            container
                            alignItems="center"
                            justifyContent="center"
                        >
                            <Grid item xs={4}>
                                <FormControl fullWidth>
                                    <InputLabel id="area-selector-label">Status</InputLabel>
                                    <Select
                                        labelId="area-selector-label"
                                        id="area-selector"
                                        value={novoStatus}
                                        onChange={(e) => setNovoStatus(e.target.value)}

                                        label="Status"
                                    >
                                        <MenuItem value={0}>Aberta</MenuItem>
                                        <MenuItem value={1}>Elaborada</MenuItem>
                                        <MenuItem value={2}>Aguardando Aprovação</MenuItem>
                                        <MenuItem value={3}>Aprovada</MenuItem>
                                        <MenuItem value={9}>Cancelada</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid
                            item xs={12}
                            style={{ margin: 2, padding: 2 }}
                        >
                            <TextField
                                label="Motivo"
                                variant="outlined"
                                fullWidth
                                minRows={3}
                                value={motivo}
                                onChange={(e) => setMotivo(e.target.value)}
                            />
                        </Grid>
                        <Grid
                            item xs={12}
                        >


                            <Button style={{ margin: 20, padding: 20 }} variant="contained" color="primary" onClick={handleClickMudarStatus}>
                                Finalizar
                            </Button>
                        </Grid>



                    </Grid>

                </DialogContent>
            </Dialog>




               <Dialog open={openTaxasInsumos} onClose={handleCloseTaxasInsumos} PaperProps={{ style: { maxWidth: '1000px', minWidth: '500px' } }}>
                <DialogTitle>Taxas para Insumos</DialogTitle>
                <DialogContent>
                    {!loading && (
                    <Grid
                        direction={"row"}
                        item xs={12}
                        container
                        alignItems={'center'}
                        justifyContent={'center'}
                        spacing={1}
                    >

                       
 <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                align="center"
                                item xs={12}
                                style={{ marginTop: 1 }}
                            >
                                <Grid
                                    container
                                    direction="column"
                                    justifyContent="center"
                                    align="center"
                                    item xs={11}
                                >

                                    <Autocomplete
                                        id="select-taxas_individuais_insumos"
                                        options={taxas}
                                        disableCloseOnSelect
                                        multiple
                                        getOptionLabel={(taxa) => returnDescricaoTaxa(taxa).replace(/<br \/>/g, '\n')}
                                        onChange={handleAdicionarTaxaIndividualInsumo}
                                        value={proposta.taxas_individuais_insumos}
                                        filterOptions={(options, { inputValue }) => {
                                            const inputKeywords = inputValue.toLowerCase().split(" ");
                                            return options.filter((questao) => {
                                                const cotacaoText = returnDescricaoTaxa(questao).toLowerCase();
                                                return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                            });
                                        }}
                                        
                                        renderInput={(params) => (
                                            <TextField {...params} label=" Taxa por item " multiline minRows={1} />
                                        )}
                                          renderOption={(option) => (
                                                <div dangerouslySetInnerHTML={{ __html: returnDescricaoTaxa(option) }} />
                                            )}
                                        renderTags={(value, getTagProps) =>
                                            value.map((taxa, index) => (
                                                <Chip
                                                    key={index}
                                                    label={taxa.nome + " | Valor: " + taxa.valor + "%"}
                                                    style={{
                                                        borderRadius: 15, // Borda arredondada
                                                        backgroundColor: '#e3f2fd', // Cor de fundo azul claro
                                                        margin: '4px', // Espaçamento entre as tags
                                                    }}
                                                    {...getTagProps({ index })}
                                                     onDelete={(event) => handleRemoverTaxaIndividualInsumo(taxa)}

                                                />
                                            ))
                                        }
                                    />
                                </Grid>
                            </Grid>
                        

                    </Grid>)}

                </DialogContent>
            </Dialog>



             <Dialog open={openTaxasOperacionais} onClose={handleCloseTaxasOperacionais} PaperProps={{ style: { maxWidth: '1000px', minWidth: '500px' } }}>
                <DialogTitle>Taxas para Custos Operacionais</DialogTitle>
                <DialogContent>
                    {!loading && (
                    <Grid
                        direction={"row"}
                        item xs={12}
                        container
                        alignItems={'center'}
                        justifyContent={'center'}
                        spacing={1}
                    >

                       
 <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                align="center"
                                item xs={12}
                                style={{ marginTop: 1 }}
                            >
                                <Grid
                                    container
                                    direction="column"
                                    justifyContent="center"
                                    align="center"
                                    item xs={11}
                                >

                                    <Autocomplete
                                        id="select-taxas_individuais_insumos"
                                        options={taxas}
                                        disableCloseOnSelect
                                        multiple
                                        getOptionLabel={(taxa) => returnDescricaoTaxa(taxa).replace(/<br \/>/g, '\n')}
                                        onChange={handleAdicionarTaxaOperacional}
                                        value={proposta.taxas_operacao}
                                        filterOptions={(options, { inputValue }) => {
                                            const inputKeywords = inputValue.toLowerCase().split(" ");
                                            return options.filter((questao) => {
                                                const cotacaoText = returnDescricaoTaxa(questao).toLowerCase();
                                                return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                            });
                                        }}
                                        
                                        renderInput={(params) => (
                                            <TextField {...params} label=" Taxa por item " multiline minRows={1} />
                                        )}
                                          renderOption={(option) => (
                                                <div dangerouslySetInnerHTML={{ __html: returnDescricaoTaxa(option) }} />
                                            )}
                                        renderTags={(value, getTagProps) =>
                                            value.map((taxa, index) => (
                                                <Chip
                                                    key={index}
                                                    label={taxa.nome + " | Valor: " + taxa.valor + "%"}
                                                    style={{
                                                        borderRadius: 15, // Borda arredondada
                                                        backgroundColor: '#e3f2fd', // Cor de fundo azul claro
                                                        margin: '4px', // Espaçamento entre as tags
                                                    }}
                                                    {...getTagProps({ index })}
                                                     onDelete={(event) => handleRemoverTaxaOperacional(taxa)}

                                                />
                                            ))
                                        }
                                    />
                                </Grid>
                            </Grid>
                        

                    </Grid>)}

                </DialogContent>
            </Dialog>


        </div >
    );
}


